import React, { useState, useRef, useEffect } from "react";
import Overlay from "../Overlay";
import "../../styles/terms.scss";
import { ReactComponent as ExpandSvg } from "../../assets/icons/expand.svg";

export const TermAndAgreement = ({ content, onAgree, onClose }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const bottomDivRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const classNames = ["terms"];
  const handleScroll = (event) => {
    const target = event.target;
    const scroll = parseInt(
      (target.scrollHeight - target.scrollTop).toFixed(0)
    );
    if (scroll === target.clientHeight) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  const handleAcceptClick = () => {
    setIsAccept((curr) => !curr);
  };

  const handleExpandClick = () => {
    setIsFullScreen((c) => !c);
  };

  const getContent = () => {
    return (
      <div className={classNames.join(" ")}>
        {/* {!isFullScreen && (
        )} */}
        <ExpandSvg className="terms__expand" onClick={handleExpandClick} />
        <div className="terms__header">Term and agreement</div>
        <div
          className={`terms-content${
            isFullScreen ? "" : isAtBottom ? "" : "__mask"
          }`}
          onScroll={handleScroll}
        >
          <h2 className="terms-content__heading">1. บทนำ</h2>
          <p className="terms-content__paragraph">
            1.1
            โปรดอ่านเงื่อนไขการให้บริการต่อไปนี้อย่างละเอียดก่อนใช้บริการแพลตฟอร์ม
            Urbaan (“แพลตฟอร์ม”) นี้หรือเปิดบัญชี Urbaan (“บัญชี”)
            เพื่อที่ท่านจะได้ทราบถึงสิทธิ หน้าที่
            และข้อผูกพันตามกฎหมายระหว่างท่านกับ บริษัท อินไซท์ สเคป จํากัด
            และบริษัทย่อยรวมถึงบริษัทในเครือ (เรียกแยกและเรียกรวมกันว่า
            “Urbaan”) “บริการ” ที่ Urbaan ได้จัดทำขึ้นหรือให้ท่านได้ใช้งาน
            รวมถึง (ก) แพลตฟอร์ม (ข) บริการที่จัดไว้ให้บนแพลตฟอร์มและแอปพลิเคชัน
            Urbaan ที่ทำให้ใช้งานได้ผ่านทางแพลตฟอร์ม และ (ค) รูปภาพ ภาพถ่าย
            กราฟิกดีไซน์ เพลง เสียง วิดีโอ (รวมถึงการทำ live stream)
            รายละเอียดข้อมูลใดที่ปรากฏบนแพลตฟอร์ม ไม่จำกัดเพียง
            ข้อมูลข่าวสารทั้งหมด ข้อความต่าง ๆ คุณสมบัติ โปรแกรม ซอฟต์แวร์
            บริการแอปพลิเคชัน เช่น แพลตฟอร์ม หรือ แอปพลิเคชันบนมือถือ เป็นต้น
            หรือสิ่งอื่นใด ที่ทำให้ใช้งานได้ผ่านทางแพลตฟอร์มหรือบริการที่เกี่ยว
            ("เนื้อหา") ทั้งนี้หาก Urbaan ได้แก้ไข หรือ
            ทำให้ดีขึ้นซึ่งบริการหรือคุณสมบัติใด ๆ
            เกี่ยวกับบริการถือว่าอยู่ภายใต้เงื่อนไขการให้บริการนี้ด้วยเช่นกัน
            เงื่อนไขการให้บริการนี้จะควบคุมการใช้บริการของท่านซึ่งจัดไว้ให้โดย
            Urbaan
          </p>
          <p className="terms-content__paragraph">
            1.2 บริการช่องทางแพลตฟอร์มออนไลน์ เพื่อการขายสินค้าและบริการต่าง ๆ
            ระหว่างผู้ซื้อ (“ผู้ซื้อ”) และผู้ขาย (“ผู้ขาย”) (เรียกรวมว่า “ท่าน”,
            “ผู้ใช้” หรือ “ผู้บริโภค”) สัญญาระหว่างผู้ซื้อและผู้ขายที่เกิดขึ้น
            เช่น สัญญาซื้อขายสินค้า สัญญาการให้บริการ สัญญาจ้างก่อสร้าง
            หรือสัญญาอื่นใด ถือว่าเป็นสัญญาระหว่างผู้ซื้อและผู้ขายโดยตรง โดยที่
            Urbaan
            ไม่ได้เป็นคู่สัญญาของสัญญาฉบับนั้นหรือสัญญาอื่นใดระหว่างผู้ซื้อและผู้ขาย
            และจะไม่ยอมรับข้อผูกพันใด ๆ ที่เกี่ยวเนื่องกับสัญญาดังกล่าว
            คู่สัญญาของธุรกรรมดังกล่าวจะเป็นผู้รับผิดชอบต่อสัญญาขายระหว่างคู่สัญญาทั้งหมด
            บัญชีรายการสินค้า การรับประกันการทำธุรกรรมและสิ่งอื่นที่คล้ายกัน
            Urbaan ไม่มีส่วนเกี่ยวข้องในธุรกรรมระหว่างผู้ใช้ Urbaan
            ไม่ทำการพิจารณาเพื่อคัดกรองล่วงหน้าต่อผู้ใช้
            หรือเนื้อหาหรือข้อมูลที่จัดไว้ให้โดยผู้ใช้ Urbaan
            ไม่สามารถรับประกันว่าผู้ใช้จะทำธุรกรรมเสร็จสิ้นจริง ๆ
            เว้นแต่จะกำหนดไว้เป็นอย่างอื่น
          </p>
          <p className="terms-content__paragraph">
            1.3 ก่อนที่จะเป็นสมาชิกของแพลตฟอร์ม
            ท่านต้องอ่านและยอมรับเงื่อนไขทั้งหมดที่เชื่อมโยงกับการให้บริการนี้และท่านต้องยินยอมรับการดำเนินการข้อมูลส่วนบุคคลของท่านดังที่อธิบายไว้ใน
            ข้อกำหนดความเป็นส่วนตัว
          </p>
          <p className="terms-content__paragraph">
            1.4 Urbaan มีสิทธิแต่เพียงผู้เดียวที่จะดำเนินการดัดแปลง แก้ไข ระงับ
            หรือยกเลิกแพลตฟอร์มนี้หรือบริการที่เกี่ยวข้องทั้งหมดหรือบางส่วนได้ตลอดเวลา
            Urbaan อาจดำเนินการออกบริการบางอย่างสำหรับรุ่นทดลอง (Beta version)
            ซึ่งอาจไม่ทำงานไม่สมบูรณ์ หรือมีข้อขัดข้องประการใดทาง Urbaan
            จะไม่รับผิดในสถานการณ์ดังกล่าว Urbaan
            ยังอาจจำกัดการเข้าถึงบางส่วนหรือทั้งหมดของแพลตฟอร์มหรือบริการโดยใช้ดุลยพินิจของ
            Urbaan แต่เพียงผู้เดียว และโดยไม่ต้องรับผิด
          </p>
          <p className="terms-content__paragraph">
            1.5 Urbaan
            สงวนสิทธิ์ในการปฏิเสธที่จะให้ท่านเข้าถึงแพลตฟอร์มหรือบริการ
            หรือปฏิเสธที่จะอนุญาตให้ท่านเปิดบัญชีไม่ว่าด้วยเหตุผลใดก็ตาม
            โดยการใช้บริการหรือเปิดบัญชี Urbaan
            ท่านได้ให้การยอมรับและความยินยอมที่เพิกถอนไม่ได้ต่อข้อตกลงนี้
            รวมถึงข้อกำหนด และเงื่อนไขเพิ่มเติมที่มีอยู่เดิมหรือเพิ่มเติมในอนาคต
            ทั้งที่อ้างถึงในที่นี่และ/หรือมีลิงก์กำหนดไว้ในที่นี้
            หากท่านไม่เห็นด้วยกับข้อตกลงนี้ โปรดงดใช้บริการหรือเข้าถึงแพลตฟอร์ม
            Urbaan
          </p>
          <p className="terms-content__paragraph">
            1.6 หากท่านอายุต่ำกว่า 20
            ปีหรือยังไม่บรรลุนิติภาวะที่จะให้คำยินยอมต่อข้อกำหนดนี้ตามประมวลกฎหมายแพ่งและพาณิชย์
            (“นิติภาวะ”) ท่านจะต้องได้รับอนุญาตและได้รับความยินยอมจากบิดามารดา
            ผู้แทนโดยชอบธรรม หรือผู้ปกครองตามกฎหมายเพื่อเปิดบัญชี
            รวมทั้งบุคคลดังกล่าวต้องเห็นด้วยกับข้อกำหนดของข้อตกลงนี้
            หากท่านไม่ทราบว่าท่านบรรลุนิติภาวะแล้วหรือยัง
            หรือไม่เข้าใจความในข้อนี้
            โปรดอย่าสร้างบัญชีจนกว่าจะได้ขอความช่วยเหลือจากบิดามารดา
            ผู้แทนโดยชอบธรรม หรือผู้ปกครองตามกฎหมายแล้ว ทั้งนี้
            หากท่านคือบิดามารดา ผู้แทนโดยชอบธรรม
            หรือผู้ปกครองตามกฎหมายของผู้เยาว์ที่กำลังสร้างบัญชี
            ท่านจะต้องยอมรับข้อกำหนดของข้อตกลงนี้แทนผู้เยาว์และท่านจะต้องรับผิดชอบต่อการใช้งานบัญชีหรือบริการของบริษัททั้งหมดจากการใช้บัญชีดังกล่าว
            ไม่ว่าบัญชีดังกล่าวจะเปิดอยู่แล้วในขณะนี้หรือสร้างขึ้นในภายหลังก็ตาม
          </p>
          <h2 className="terms-content__heading">2. ซอฟต์แวร์</h2>
          <p className="terms-content__paragraph">
            2.1 ซอฟต์แวร์ที่ Urbaan จัดไว้ให้ท่านเป็นส่วนหนึ่งของบริการนี้
            อยู่ภายใต้ข้อกำหนดของเงื่อนไขการให้บริการนี้ Urbaan
            สงวนสิทธิ์ทั้งหมดต่อซอฟต์แวร์ที่ไม่ได้อนุญาตไว้อย่างชัดแจ้งโดย
            Urbaan ในที่นี้ สคริปต์หรือรหัสของบุคคลภายนอก
            ที่เชื่อมโยงไปยังหรืออ้างถึงจากบริการ
            บุคคลภายนอกที่เป็นเจ้าของสคริปต์หรือรหัสดังกล่าวเป็นผู้มอบสิทธิ์การใช้งานให้แก่ท่าน
            ไม่ใช่มอบให้โดย Urbaan
          </p>
          <h2 className="terms-content__heading">3. สิทธิการใช้งานแบบจำกัด</h2>
          <p className="terms-content__paragraph">
            3.1 การเข้าถึงและใช้บริการตามข้อกำหนด และเงื่อนไขของให้บริการนี้
            เนื้อหา เครื่องหมายการค้า เครื่องหมายบริการ ชื่อตราสินค้า โลโก้
            และทรัพย์สินทางปัญญาอื่น ๆ ที่มีกรรมสิทธิ์ทั้งหมด
            (“ทรัพย์สินทางปัญญา”) ที่แสดงในแพลตฟอร์ม
            อยู่ภายใต้การใช้งานแบบจำกัดและเพิกถอนได้ในการเข้าถึงและใช้บริการตามข้อกำหนด
            และเงื่อนไขของเงื่อนไขการให้บริการนี้
          </p>
          <p className="terms-content__paragraph">
            3.2 ทรัพย์สินทางปัญญา ที่แสดงในแพลตฟอร์ม เป็นทรัพย์สินของ Urbaan
            และบางกรณี
            เป็นทรัพย์สินของบุคคลภายนอกที่ถือกรรมสิทธิ์ตามที่ระบุไว้ในแพลตฟอร์ม
            ไม่มีการมอบสิทธิหรือสิทธิ์การใช้งานทั้งโดยตรงหรือโดยอ้อมแก่บุคคลใดที่เข้าถึงแพลตฟอร์มเพื่อใช้งานหรือลอกเลียนแบบทรัพย์สินทางปัญญาใด
            และไม่มีบุคคลใดที่เข้าถึงแพลตฟอร์มจะสามารถอ้างสิทธิ กรรมสิทธิ์
            หรือผลประโยชน์ในแพลตฟอร์มนี้ได้ โดยการใช้หรือเข้าถึงบริการ
            ท่านตกลงที่จะปฏิบัติตามกฎหมายเกี่ยวกับทรัพย์สินทรัพย์สินทางปัญญาที่เกี่ยวข้อง
            และกฎหมายที่บังคับใช้อื่น ๆ ทั้งหมด ที่คุ้มครองบริการ แพลตฟอร์ม
            และเนื้อหาในแพลตฟอร์ม ท่านตกลงที่จะไม่ทำซ้ำ
            จำหน่ายไม่ว่าจะมีค่าตอบแทนหรือไม่ แสดงแก่สาธารณะ เผยแพร่ ส่งต่อ
            ต่อสาธารณะ ปรับเปลี่ยน ดัดแปลง ขาย ให้เช่า
            หรือสร้างงานจากส่วนหนึ่งส่วนใดของบริการ แพลตฟอร์ม
            หรือเนื้อหาในแพลตฟอร์ม
            ท่านยังจะต้องไม่ใช้หรือแสดงเนื้อหาในแพลตฟอร์มนี้
            ไม่ว่าทั้งหมดหรือส่วนหนึ่งส่วนใดบนเซิร์ฟเวอร์อื่นใด
            หรือเป็นส่วนหนึ่งของเว็บแพลตฟอร์มอื่น
            โดยไม่ได้รับคำยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก Urbaan นอกจากนี้
            ท่านตกลงว่าจะไม่ใช้ โปรแกรม อุปกรณ์อัตโนมัติ หรือกระบวนการใด ๆ
            เพื่อเฝ้าติดตามหรือคัดลอกเนื้อหาของ Urbaan
            โดยไม่ได้รับคำยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก Urbaan ทั้งนี้
            คำยินยอมดังกล่าวจะถือว่ามอบให้สำหรับเทคโนโลยีเครื่องมือค้นหามาตรฐานที่ใช้โดยเว็บไซต์ค้นหาทางอินเทอร์เน็ตเพื่อนำผู้ใช้อินเทอร์เน็ตมายังแพลตฟอร์มนี้
          </p>
          <p className="terms-content__paragraph">
            3.3 เว็บไซต์ของท่านสามารถเชื่อมโยงมายังแพลตฟอร์มได้
            โดยอยู่ภายใต้เงื่อนไขว่าเว็บไซต์ของท่านไม่ได้แสดงนัยของการรับรองโดยหรือเชื่อมโยงกับแพลตฟอร์ม
            หรือ Urbaan ท่านรับทราบว่า Urbaan
            อาจมีดุลยพินิจแต่เพียงผู้เดียวในการยกเลิกการให้บริการไม่ว่าทั้งหมดหรือบางส่วนได้ตลอดเวลา
          </p>
          <h2 className="terms-content__heading">4. ความเป็นส่วนตัว</h2>
          <p className="terms-content__paragraph">
            4.1 เพื่อให้คุ้มครองสิทธิของท่าน Urbaan
            จึงได้จัดทำ[ข้อกำหนดความเป็นส่วนตัว]ของ Urbaan
            เพื่ออธิบายแนวทางปฏิบัติด้านการจัดการความเป็นส่วนตัวอย่างละเอียด
            โปรดอ่านข้อกำหนดความเป็นส่วนตัวนี้เพื่อให้เข้าใจว่า Urbaan
            เก็บรวบรวมและใช้ข้อมูลที่เกี่ยวกับบัญชีของท่านและ/หรือการใช้งานบริการของท่านอย่างไร
            (“ข้อมูลของผู้ใช้”) โดยการใช้บริการหรือให้ข้อมูลทางแพลตฟอร์ม
            ท่านตกลงยอมรับดังต่อไปนี้ (1)
            ตกลงและยอมรับว่าสิทธิการเป็นเจ้าของในข้อมูลของผู้ใช้เป็นของ Urbaan
            และของท่านร่วมกัน (2) ยินยอมให้ Urbaan เก็บรวบรวม ใช้งาน เปิดเผย
            และ/หรือดำเนินการกับเนื้อหา
            ข้อมูลส่วนบุคคลของท่านและข้อมูลของผู้ใช้ตามที่อธิบายไว้ในข้อกำหนดความเป็นส่วนตัวร่วมกัน
            (3) จะไม่เปิดเผยข้อมูลของผู้ใช้ต่อบุคคลภายนอก
            ไม่ว่าบางส่วนหรือทั้งหมด
            หรือยินยอมให้บุคคลภายนอกเข้าถึงหรือใช้ข้อมูลของผู้ใช้ของท่านโดยไม่ได้รับความยินยอมจาก
            Urbaan เป็นลายลักษณ์อักษรก่อน
          </p>
          <p className="terms-content__paragraph">
            4.2 ผู้ใช้ที่ครอบครองข้อมูลส่วนบุคคลของผู้ใช้คนอื่นผ่านการใช้บริการ
            (“ฝ่ายผู้รับ”) ตกลงว่าจะ (1)
            ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่บังคับใช้ทั้งหมดอันเกี่ยวกับข้อมูลดังกล่าว
            (2) อนุญาตให้ผู้ใช้ ซึ่งฝ่ายผู้รับได้เก็บรวบรวมข้อมูลส่วนบุคคลไว้
            (“ฝ่ายผู้เปิดเผย”)
            ลบข้อมูลของตนที่เก็บรวบรวมไว้ออกจากฐานข้อมูลของฝ่ายผู้รับ และ (3)
            อนุญาตให้ฝ่ายผู้เปิดเผยตรวจสอบว่าฝ่ายผู้รับมีการเก็บรวบรวมข้อมูลใดบ้างเกี่ยวกับตน
            ในแต่ละกรณีของข้อ (2) และข้อ (3) ข้างต้น
            ตามและเมื่อกฎหมายที่บังคับใช้กำหนดไว้
          </p>
          <h2 className="terms-content__heading">5. บัญชีและความปลอดภัย</h2>
          <p className="terms-content__paragraph">
            5.1 การเข้าถึงหรือใช้งานแพลตฟอร์มบางอย่างสำหรับบริการของ Urbaan
            ต้องมีการลงทะเบียนบัญชีโดยเลือกรหัสประจำตัวผู้ใช้ที่ไม่ซ้ำกัน
            ("รหัสประจำตัวผู้ใช้") และรหัสผ่าน โดยการให้ข้อมูลส่วนบุคคลบางอย่าง
            หากท่านเลือก รหัสประจำตัวผู้ใช้ ที่ตามดุลยพินิจแต่เพียงผู้เดียวของ
            Urbaan เห็นว่า ขัดต่อความสงบเรียบร้อยและศีลธรรมอันดี สร้างความแตกแยก
            หรือไม่เหมาะสม Urbaan มีสิทธิที่จะระงับหรือยกเลิกบัญชีของท่านได้
            ท่านอาจสามารถใช้บัญชีเพื่อเข้าถึงผลิตภัณฑ์ เว็บไซต์ หรือบริการอื่น ๆ
            ซึ่ง Urbaan อนุญาตให้เข้าถึงได้ หรือที่เชื่อมโยงกันหรือทำงานร่วมกัน
            Urbaan ไม่ได้ตรวจสอบ และไม่รับผิดชอบต่อเนื้อหาของบุคคลภายนอก
            ความปลอดภัย บริการ ฟังก์ชั่นการทำงาน ข้อกำหนดความเป็นส่วนตัว
            หรือการปฏิบัติอื่น ๆ ของผลิตภัณฑ์ เว็บไซต์ หรือบริการเหล่านั้น
            หากท่านกระทำการดังกล่าว เงื่อนไขการให้บริการของผลิตภัณฑ์ เว็บไซต์
            หรือบริการเหล่านั้น รวมถึงข้อกำหนดความเป็นส่วนตัวที่เกี่ยวข้อง
            หากแตกต่างจากเงื่อนไขการให้บริการและ/หรือข้อกำหนดความเป็นส่วนตัวของ
            Urbaan อาจบังคับใช้กับการใช้ผลิตภัณฑ์ เว็บไซต์
            หรือบริการเหล่านั้นของท่าน
          </p>
          <p className="terms-content__paragraph">
            5.2 ท่านตกลงว่า (1)
            เมื่อเข้าสู่ระบบในแพลตฟอร์มจะเก็บรักษารหัสผ่านไว้เป็นความลับและใช้เฉพาะรหัสประจำตัวผู้ใช้และรหัสผ่านของตนเอง
            (2)
            ดำเนินการตรวจสอบว่าท่านออกจากระบบบัญชีเมื่อสิ้นสุดแต่ละเซสชันบนแพลตฟอร์ม
            (3) หากมีการใช้บัญชี รหัสประจำตัวผู้ใช้
            และ/หรือรหัสผ่านของท่านโดยไม่ได้รับอนุญาต ท่านจะแจ้ง Urbaan ทันที
            (4)
            ตรวจสอบให้แน่ใจว่าข้อมูลบัญชีของท่านถูกต้องและเป็นปัจจุบันอยู่เสมอ
          </p>
          <p className="terms-content__paragraph">
            5.3 ท่านต้องรับผิดชอบอย่างเต็มที่ต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้
            รหัสประจำตัว ผู้ใช้และบัญชีของท่าน
            รวมทั้งในกรณีที่ท่านไม่ได้ทำกิจกรรมหรือทำการใช้งานดังกล่าวก็ตาม
            ทั้งนี้ Urbaan
            จะไม่รับผิดต่อความความเสียหายหรือสูญเสียที่เกิดจากการที่ท่านไม่สามารถปฏิบัติตามความในส่วนนี้
            หรือ การใช้รหัสผ่านของท่านโดยไม่ได้อนุญาต
          </p>
          <p className="terms-content__paragraph">
            5.4 ท่านเป็นอันตกลงว่า Urbaan อาจ ระงับหรือยกเลิกบัญชีและ
            รหัสประจำตัว ผู้ใช้ของท่านทันที ปรับเปลี่ยน จำกัด ระงับ
            หรือยกเลิกการใช้งานหรือการเข้าถึงแพลตฟอร์มหรือส่วนหนึ่งส่วนใดของแพลตฟอร์ม
            เพิกถอนหรือลบเนื้อหาใดก็ตามที่เกี่ยวข้องกับบัญชีหรือ
            รหัสประจำตัวผู้ใช้ของท่านออกจากแพลตฟอร์ม
            ยกเลิกหรือเรียกคืนการสนับสนุนใด ๆ ที่ให้แก่ท่าน และ/หรือ
            ยกเลิกหรือระงับธุรกรรมใด ๆ ที่เกี่ยวข้องกับบัญชีหรือ
            รหัสประจำตัวผู้ใช้ของท่าน
            ไม่ว่าด้วยเหตุผลใดและตามดุลยพินิจแต่เพียงผู้เดียวของ Urbaan
            และโดยไม่ต้องรับผิดต่อท่านหรือบุคคลภายนอกใด ๆ ทั้งนี้
            เป็นการชั่วคราว
            หรือในกรณีที่ร้ายแรงกว่านั้นอาจระงับการขายหรือการคืนเงินใด ๆ
            อย่างถาวรและ/หรือใช้มาตราการอื่นใดที่ Urbaan เห็นสมควร
            โดยการแจ้งให้ทราบล่วงหน้าภายในระยะอันสมควรตามที่กฎหมายที่ใช้บังคับกำหนด
            เว้นแต่กรณีความผิดร้ายแรงหรือการกระทำความผิดซ้ำซึ่งไม่ต้องแจ้งให้ทราบล่วงหน้า
            ซึ่งมูลเหตุสำหรับการดำเนินการดังกล่าวอาจ รวมถึงแต่ไม่จำกัดเพียง
            กรณีที่มีพฤติการณ์
            หรือมีข้อสงสัยว่าได้มีพฤติการณ์ดังต่อไปนี้เกิดขึ้น (1)
            การไม่มีการใช้งานเป็นเวลานาน ตามเงื่อนไขที่ Urbaan
            กำหนดเป็นครั้งคราว (2) พฤติกรรมผิดกฎหมาย คุกคาม หรือขู่เข็ญ
            ล่วงละเมิด ฉ้อฉล ทำให้เสื่อมเสีย (3)
            การละเมิดเจตนารมณ์หรือตัวอักษรของเงื่อนไขการให้บริการนี้ (4)
            การซื้อสินค้าจากผู้ขายรายเดียวหรือกลุ่มผู้ขายเดียวกันในลักษณะที่ผิดปกติวิสัยหรือในปริมาณที่มากเกินปกติ
            (5) การซื้อสินค้าจากแพลตฟอร์มโดยมีวัตถุประสงค์เพื่อการจำหน่ายต่อ (6)
            การมีบัญชีผู้ใช้หลายบัญชีเพื่อเหตุอันมิชอบด้วยกฎหมาย (7)
            พฤติกรรมที่เป็นอันตรายต่อผู้ใช้คนอื่น บุคคลภายนอก
            หรือผลประโยชน์ทางธุรกิจของ Urbaan ทั้งนี้
            กรณีการใช้บัญชีเพื่อจุดประสงค์ที่ผิดกฎหมาย คุกคาม หรือขู่เข็ญ
            ล่วงละเมิด ฉ้อฉล ทำให้เสื่อมเสีย
            อาจมีการแจ้งให้หน่วยงานบังคับใช้กฎหมายทราบโดยไม่ต้องแจ้งแก่ท่าน
            หากเกิดข้อพิพาททางกฎหมายหรือการดำเนินคดีเกี่ยวกับบัญชีหรือการใช้บริการของท่าน
            ไม่ว่าด้วยเหตุผลใดก็ตาม Urbaan
            อาจยกเลิกบัญชีของท่านทันทีโดยแจ้งให้ท่านทราบผ่านทางแพลตฟอร์ม
          </p>
          <p className="terms-content__paragraph">
            5.5 ผู้ใช้สามารถยกเลิกบัญชีของตนได้หากแจ้งให้ Urbaan
            ทราบเป็นลายลักษณ์อักษร (รวมทั้งทางอีเมลแจ้ง Urbaan ผ่านที่อยู่อีเมล
            admin@urbaancommunities.com ) ว่าประสงค์ที่จะดำเนินการดังกล่าว
            อย่างไรก็ดี
            ผู้ใช้ยังคงต้องรับผิดชอบและรับผิดต่อธุรกรรมใดก็ตามที่ยังทำไม่เสร็จสิ้น
            เช่น การชำระค่าสินค้าหรือบริการ
            (ไม่ว่าจะเริ่มก่อนหรือหลังการยกเลิกดังกล่าว) หรือ
            งานที่ยังไม่เสร็จสิ้น และผู้ใช้จะต้องติดต่อ Urbaan
            หลังจากได้ดำเนินการและทำธุรกรรมที่ยังไม่เสร็จสิ้นทั้งหมดให้เสร็จสิ้นในทันทีตามเงื่อนไขการให้บริการนี้
            Urbaan ไม่ต้องรับผิด
            และไม่ต้องรับผิดต่อความเสียหายที่เกิดขึ้นอันเนื่องมาจากการดำเนินการตามส่วนนี้
            ผู้ใช้จะสละสิทธิ์ในการเรียกร้องใดๆ
            และทั้งหมดบนพื้นฐานการดำเนินการดังกล่าวโดย Urbaan
          </p>
          <h2 className="terms-content__heading">6. เงื่อนไขการใช้งาน</h2>
          <p className="terms-content__paragraph">
            6.1 สิทธิ์การใช้งานแพลตฟอร์มนี้และบริการมีผลจนกว่าจะมีการยกเลิก
            สิทธิ์การใช้งานนี้จะยกเลิกตามที่ระบุไว้ในเงื่อนไขการให้บริการ
            หรือเมื่อท่านไม่ปฏิบัติตามข้อกำหนดหรือเงื่อนไขใด ๆ
            ของเงื่อนไขการให้บริการนี้ ในกรณีดังกล่าว
            เพื่อให้การยกเลิกดังกล่าวมีผลไม่จำเป็นต้องแจ้งทาง Urbaan
            ให้ทราบล่วงหน้า
          </p>
          <p className="terms-content__paragraph">
            6.2 ท่านตกลงที่จะไม่: (1) แสดง อัปโหลด หรือ
            ส่งต่อเนื้อหาในลักษณะที่ผิดกฎหมาย เป็นภัย ล่วงละเมิด ทำให้ตื่นตกใจ
            คุกคาม ขู่เข็ญ ทำให้เป็นทุกข์ หลอกลวง ลามก หมิ่นประมาท
            ทำให้เสื่อมเสีย หยาบคาย ละเอียดอ่อนทางการเมือง
            ล่วงล้ำความเป็นส่วนตัวของผู้อื่น เหยียดเชื้อชาติหรือชาติพันธุ์
            น่ารังเกียจ (2)
            ละเมิดกฎหมายและข้อบังคับที่เกี่ยวกับข้อจำกัดการคุ้มครองผู้บริโภค
            ควบคุมอาคาร หรือการโฆษณาอย่างใด (3) แสดง อัปโหลด
            ส่งต่อหรือกระทำเนื้อหาใด ๆ
            ที่ส่วนเกี่ยวข้องกับการใช้ผู้เยาว์ที่ไม่เป็นไปตามที่กฎหมายกำหนด
            หรือทำให้ผู้เยาว์ได้รับความเสียหายไม่ว่าทางใด (4)
            ใช้บริการหรืออัปโหลดเนื้อหาเพื่อปลอมแปลงเป็นบุคคลหรือนิติบุคคลอื่นหรือข้อมูลอันเป็นเท็จทำให้เข้าใจว่าเป็นและ/หรือมีความเชื่อมโยงบุคคลหรือนิติบุคคลอื่น
            (5) เป็นต้นเหตุ อนุญาตหรือมอบอำนาจให้ทำการ ทำซ้ำ ดัดแปลง สร้างงาน
            หรือแปลบริการโดยไม่ได้รับอนุญาตอย่างชัดแจ้งเป็นลายลักษณ์อักษรจาก
            Urbaan (6) ใช้บริการหรืออัปโหลดเนื้อหาในลักษณะที่ไม่เป็นความจริง
            ไม่เหมาะสม เป็นการฉ้อฉล ชี้นำไปในทางที่ผิดหรือเป็นการหลอกลวง
            ผิดจรรยาบรรณ (7)
            ใช้บริการเพื่อประโยชน์ของบุคคลภายนอกหรือในลักษณะที่ไม่ได้รับอนุญาตตามสิทธิ์การใช้งานที่ให้ไว้
            (8) เข้าถึงแพลตฟอร์มของ Urbaan
            เปิดบัญชีผู้ใช้หรือเข้าถึงบัญชีผู้ใช้ของท่านโดยใช้ซอฟต์แวร์
            ฮาร์ดแวร์ ชุดคำสั่ง หรือโปรแกรมที่ไม่เป็นทางการของ Urbaan (9)
            เปิดใช้หรือมีบัญชีผู้ใช้หลายบัญชีเพื่อกระทำการใด ๆ
            ที่เป็นการละเมิดข้อกำหนดหรือวัตถุประสงค์ของข้อกำหนดเงื่อนไขการให้บริการนี้
            (10)
            ปรับเปลี่ยนราคาของสินค้าหรือแทรกแซงบัญชีรายชื่อสินค้าหรือบริการของผู้ใช้รายอื่น
            (11) ดำเนินการใด ๆ
            ที่อาจมีวัตถุประสงค์ทำลายระบบแสดงความคิดเห็นหรือระบบการให้คะแนน (12)
            เก็บเกี่ยวหรือเก็บรวบรวมข้อมูลเกี่ยวกับเจ้าของบัญชีคนอื่น รวมถึง
            โดยไม่จำกัดเพียงข้อมูลส่วนบุคคลใด ๆ (13) พยายามแยกส่วนแฟ้ม
            ทำวิศวกรรมย้อนกลับ ถอดประกอบหรือเจาะระบบบริการ
            หรือส่วนหนึ่งส่วนใดของบริการ
            หรือเอาชนะหรือทำลายเทคโนโลยีการเข้ารหัสหรือมาตรการความปลอดภัยที่
            Urbaan นำมาใช้กับบริการและ/หรือข้อมูลที่ส่งต่อ ดำเนินการ
            หรือจัดเก็บไว้โดย Urbaan (14) แสดง อัปโหลด อีเมล ส่งต่อ
            หรือทำให้เนื้อหาที่ท่านไม่มีสิทธิ์ทำให้ใช้งานได้ภายใต้กฎหมายหรือภายใต้ความสัมพันธ์ตามสัญญาหรือการมอบอำนาจ
            เช่น ข้อมูลภายใน
            ข้อมูลที่เป็นกรรมสิทธิ์และข้อมูลลับที่ได้ทราบหรือถูกเปิดเผยจากความสัมพันธ์ในการจ้างงานหรือภายใต้ข้อตกลงไม่เปิดเผยข้อมูล
            (15) แสดง อัปโหลด อีเมล ส่งต่อ
            หรือทำให้เนื้อหาที่ละเมิดทรัพย์สินทางปัญญา รวมถึงแต่ไม่จำกัดเพียง
            ลิขสิทธิ์ สิทธิบัตร เครื่องหมายการค้า ความลับทางการค้า
            หรือกรรมสิทธิ์อื่น ๆ ของบุคคลอื่น ใช้งานได้ (16) แสดง อัปโหลด อีเมล
            ส่งต่อ หรือทำให้วัสดุอื่น ๆ ที่มีไวรัสซอฟต์แวร์ หนอน ม้าโทรจัน
            หรือรหัสคอมพิวเตอร์ รูทีน
            ไฟล์หรือโปรแกรมที่ออกแบบมาเพื่อแทรกแซงทั้งโดยตรงและโดยอ้อมต่อ
            ปรับเปลี่ยน ขัดขวาง ทำลาย
            หรือจำกัดฟังก์ชั่นการทำงานของซอฟต์แวร์คอมพิวเตอร์หรือฮาร์ดแวร์ใด ๆ
            หรือข้อมูลหรืออุปกรณ์โทรคมนาคม ใช้งานได้ (17) แสดง อัปโหลด อีเมล
            ส่งต่อ หรือทำให้โฆษณาที่ไม่ได้ร้องขอหรือได้รับอนุญาต
            สื่อประชาสัมพันธ์ เมลขยะ สแปม จดหมายลูกโซ่ ธุรกิจแบบพีระมิด
            หรือรูปแบบการเชิญชวนอื่นใดที่ไม่ได้รับอนุญาต ใช้งานได้ (18) แทรกแซง
            ปรับเปลี่ยน
            หรือขัดขวางบริการหรือเซิร์ฟเวอร์หรือเครือข่ายที่เชื่อมต่อกับบริการหรือการใช้งานของผู้ใช้คนอื่น
            หรือฝ่าฝืนข้อกำหนด กระบวนการ นโยบาย
            หรือข้อบังคับของเครือข่ายที่เชื่อมต่อกับแพลตฟอร์ม (19)
            ดำเนินการหรือเข้าร่วมในการกระทำที่อาจส่งผลเสียหายทั้งทางตรงหรือทางอ้อม
            ปิดใช้งาน สร้างภาระหนัก
            หรือทำให้บริการหรือเซิร์ฟเวอร์หรือเครือข่ายที่เชื่อมต่อกับบริการมีข้อบกพร่อง
            (20) ใช้บริการเพื่อเจตนาหรือไม่เจตนาฝ่าฝืนกฎหมาย กฎระเบียบ
            ประมวลกฎหมาย คำสั่ง แนวทางปฏิบัติ หรือข้อบังคับของ ประเทศ (21)
            ใช้บริการเพื่อฝ่าฝืนความเป็นส่วนตัวของผู้อื่น หรือ ติดตาม
            หรือก่อกวนผู้อื่น (23) ละเมิดสิทธิต่าง ๆ ของ Urbaan
            ซึ่งรวมถึงสิทธิในทรัพย์สินทางปัญญาและการลวงขาย
            ตามกฎหมายหรือระเบียบที่เกี่ยวข้อง (24)
            ใช้บริการเพื่อเก็บรวบรวมหรือจัดเก็บข้อมูลส่วนบุคคลเกี่ยวกับผู้ใช้คนอื่นที่เกี่ยวกับการกระทำและกิจกรรมต้องห้ามที่ระบุไว้ด้านบน
            (25) ลงรายการที่ละเมิดทรัพย์สินทางปัญญา ลิขสิทธิ์ สิทธิบัตร
            เครื่องหมายการค้า หรือสิทธิในทรัพย์สินทางปัญหาของบุคคลภายนอกหรือ
            ใช้บริการในลักษณะที่จะละเมิดสิทธิ์ในทรัพย์สินทางปัญญาของผู้อื่น
            และ/หรือ (26) สั่ง หรือ สนับสนุนให้ผู้ใช้ทำธุรกรรมนอกแพลตฟอร์ม
          </p>
          <p className="terms-content__paragraph">
            6.3 ท่านรับทราบว่า Urbaan อาจหรืออาจไม่คัดกรองเนื้อหาล่วงหน้า
            อย่างไรก็ตาม ตามดุลยพินิจแต่เพียงผู้เดียวของ Urbaan
            และผู้ที่ได้รับการแต่งตั้งจาก Urbaan
            จะมีสิทธิ์แต่ไม่ใช่ข้อผูกพันในการคัดกรองล่วงหน้า ปฏิเสธ
            ลบหรือย้ายเนื้อหาใด ๆ ที่ใช้งานได้บนแพลตฟอร์ม โดยไม่มีความรับผิดใด ๆ
            ต่อท่าน โดยไม่เป็นการจำกัดสิ่งที่กล่าวไปก่อนหน้า Urbaan
            และผู้ที่ได้รับการแต่งตั้งจาก Urbaan มีสิทธิ์ที่จะลบเนื้อหา (1)
            ที่ละเมิดเงื่อนไขการให้บริการ
            หรือนโยบายสิ่งของต้องห้ามและสิ่งของที่ถูกจำกัดของ Urbaan
            รวมทั้งข้อกำหนดและเงื่อนไขใดๆ ของ Urbaan (2) ถ้า Urbaan
            ได้รับแจ้งหรือได้รับการกล่าวหาเกี่ยวกับการละเมิดทรัพย์สินทางปัญญาหรือคำสั่งทางกฎหมายหรือคำร้องให้ลบออก
            (3) ถ้าเนื้อหาดังกล่าวไม่เหมาะสมหรือน่ารังเกียจ หรือ (4) ถ้า Urbaan
            ได้รับคำร้องเรียนจากผู้ใช้คนอื่น Urbaan
            ยังอาจปิดกั้นการส่งการสื่อสาร รวมถึงแต่ไม่จำกัดเพียง การอัปเดตสถานะ
            การแสดง ข้อความ และ/หรือการสนทนา ไปยังหรือจากบริการ
            อันเป็นส่วนหนึ่งของความพยายามของ Urbaan
            ที่จะบังคับใช้บทบัญญัติของข้อกำหนดและเงื่อนไขเหล่านี้ หรือ
            ปกป้องบริการหรือผู้ใช้ของ Urbaan ท่านตกลงว่าท่านจะต้องประเมิน
            และแบกรับความเสี่ยงทั้งหมดที่เกี่ยวกับการใช้เนื้อหา
            รวมถึงแต่ไม่จำกัดเพียง การพึ่งพาความถูกต้อง ความครบถ้วน
            หรือประโยชน์ของเนื้อหาดังกล่าว เกี่ยวกับเรื่องนี้
            ท่านรับทราบว่าท่านไม่ได้
            และจนถึงขอบเขตสูงสุดที่กฎหมายที่เกี่ยวข้องอนุญาตไว้
            ไม่สามารถพึ่งพาเนื้อหาที่ Urbaan สร้างขึ้น หรือส่งมายัง Urbaan
            รวมถึงในส่วนอื่น ๆ ทั้งหมดของแพลตฟอร์ม
          </p>
          <p className="terms-content__paragraph">
            6.4 ท่านรับทราบ ยินยอม และตกลงว่า Urbaan อาจเข้าถึง รักษา
            และเปิดเผยข้อมูลบัญชีของท่านและเนื้อหาของท่านต่อหน่วยงานทางกฎหมายหรือผู้มีอำนาจภายในรัฐ
            เจ้าของสิทธิที่เกี่ยวข้องหรือบุคคลที่สามอื่น ๆ
            เพื่อให้เป็นไปตามที่กฎหมายกำหนด
            หรือตามคำสั่งศาลหรือโดยหน่วยงานรัฐหรือหน่วยงานทางกฎหมายที่มีเขตอำนาจเหนือ
            Urbaan
            หรือโดยการเชื่อโดยสุจริตว่าการเข้าถึงเพื่อรักษาหรือเปิดเผยนั้นมีความจำเป็นตามสมควรเพื่อ:
            (1) ปฏิบัติตามขั้นตอนทางกฎหมาย (2)
            ตอบสนองต่อข้อเรียกร้องที่ว่าเนื้อหาใดละเมิดสิทธิของบุคคลภายนอกรวมถึงสิทธิในทรัพย์สินทางปัญญา
            (3) ปกป้องสิทธิ ทรัพย์สินหรือความปลอดภัยส่วนบุคคลของ Urbaan
            ผู้ใช้และ/หรือประชาชนทั่วไป (4) ตอบสนองต่อคำขอการบริการลูกค้าของท่าน
            หรือ (5) บังคับใช้เงื่อนไขการให้บริการนี้หรือ
            นโยบายสิ่งของต้องห้ามและสิ่งของที่ถูกจำกัดของ Urbaan
            รวมทั้งข้อกำหนดและเงื่อนไขใด ๆ ของ Urbaan
          </p>
          <p className="terms-content__paragraph">
            6.5 ท่านเข้าใจว่าเนื้อหาทั้งหมด
            ไม่ว่าส่งต่อแบบเป็นส่วนตัวหรือแสดงต่อสาธารณะหรือ
            เป็นความรับผิดชอบของผู้ที่เป็นต้นกำเนิดของเนื้อหาดังกล่าวแต่เพียงผู้เดียว
            นั่นหมายความว่า ท่าน ไม่ใช่ Urbaan
            ที่ต้องรับผิดชอบต่อเนื้อหาทั้งหมดที่ท่าน แสดง อัปโหลด อีเมล ส่งต่อ
            หรือทำให้ใช้งานได้ทางแพลตฟอร์มแต่เพียงผู้เดียว Urbaan
            ไม่ควบคุมเนื้อหาที่แสดงบนแพลตฟอร์ม และดังนั้น
            จึงไม่รับประกันความถูกต้อง ความสมบูรณ์ หรือท่านภาพของเนื้อหาดังกล่าว
            ท่านเข้าใจว่าในการใช้แพลตฟอร์ม
            ท่านอาจพบเจอกับเนื้อหาที่อาจถือได้ว่าสร้างความขุ่นเคืองใจ
            ลามกอนาจารหรือน่ารังเกียจ
            จนถึงขอบเขตสูงสุดที่กฎหมายที่เกี่ยวข้องอนุญาตไว้ ไม่ว่าในกรณีใดก็ตาม
            Urbaan จะไม่รับผิดไม่ว่าในทางใดต่อเนื้อหา รวมถึงแต่ไม่จำกัดเพียง
            ข้อผิดพลาด หรือการละเว้นเนื้อหา
            หรือการสูญเสียหรือความเสียหายชนิดใดก็ตามที่เกิดขึ้นอันเป็นผลมาจากการใช้
            หรือการพึ่งพาเนื้อหาที่แสดง อีเมล ส่งต่อ
            หรือทำให้ใช้งานได้บนแพลตฟอร์ม
          </p>
          <h2 className="terms-content__heading">
            7. การฝ่าฝืนหรือละเมิดเงื่อนไขการให้บริการ
          </h2>
          <p className="terms-content__paragraph">
            7.1 หาก Urbaan พบว่ามีการฝ่าฝืนละเมิดเงื่อนไขการให้บริการนี้
            รวมถึงเงื่อนไข ข้อกำหนด และนโยบายใด ๆ ของ Urbaan ทาง Urbaan
            มีสิทธิแต่เพียงผู้เดียวที่จะดำเนินการ รวมถึงแต่ไม่จำกัดเพียง
            สิ่งใดสิ่งหนึ่งหรือทั้งหมดต่อไปนี้
          </p>
          <p className="terms-content__paragraph">• ลบบัญชีผู้ใช้</p>
          <p className="terms-content__paragraph">• จำกัดสิทธิพิเศษของบัญชี</p>
          <p className="terms-content__paragraph">
            • ระงับบัญชีและยกเลิกในเวลาต่อมา
          </p>
          <p className="terms-content__paragraph">• ดำเนินคดีทางแพ่ง</p>
          <p className="terms-content__paragraph">• ดำเนินคดีอาญา</p>
          <p className="terms-content__paragraph">
            7.2 หากท่านพบเบาะแสว่าผู้ใช้บนแพลตฟอร์มของ Urbaan
            ละเมิดเงื่อนไขการให้บริการนี้ โปรดติดต่อ Urbaan ผ่านที่อยู่อีเมล
            admin@urbaancommunities.com
          </p>
          <h2 className="terms-content__heading">
            8. การคุ้มครองทรัพย์สินทางปัญญา
          </h2>
          <p className="terms-content__paragraph">
            ผู้ขายมีหน้าที่รับผิดชอบในการตรวจสอบให้แน่ใจว่าสินค้า บริการ
            ผลิตภัณฑ์และเนื้อหาของตน (เช่น วีดีโอ รูปภาพ แบบก่อสร้าง คำอธิบาย
            เป็นต้น) ไม่ได้เป็นการละเมิดสิทธิ์ในทรัพย์สินทางปัญญาของบุคคลอื่นใด
            รายการสินค้าหรือบริการอาจถูกลบโดยไม่ต้องแจ้งให้ทราบหากมีรายงานว่าผู้ขายได้มีการละเมิดทรัพย์สินทางปัญญาใด
            ๆ ที่ไม่ใช่ของผู้ขายเอง ทั้งนี้ Urbaan มีมาตรการสอดส่อง
            ควบคุมไม่ให้มีการละเมิดทรัพย์สินทางปัญญาเกิดขึ้นบนแพลตฟอร์มของ
            Urbaan เมื่อมีการละเมิดทรัพย์สินทางปัญญาเกิดขึ้น
            ก็ยังคงเป็นความรับผิดชอบของผู้ขายเอง
            ดังนั้นผู้ขายจะต้องมั่นใจว่ารายการสินค้าที่นำมาลงขายในส่วนของ
            ตัวสินค้า หรือ ผลิตภัณฑ์ ชื่อ คำอธิบายเนื้อหา รวมถึงรูปภาพสินค้า
            จะต้องไม่เข้าข่ายละเมิดทรัพย์สินทางปัญญาของบุคคลอื่น
          </p>
          <p className="terms-content__paragraph">
            อย่างไรก็ดี เพื่อให้เป็นไปตามกฎหมาย Urbaan ได้ดำเนินการบังคับใช้
            มาตรการแจ้งเตือน (The Notice and Takedown)
            โดยเจ้าของลิขสิทธิ์สามารถส่งข้อมูลการละเมิดมายัง Urbaan เพื่อให้
            Urbaan นำข้อมูลคอมพิวเตอร์ที่มีการละเมิดลิขสิทธิ์ ออกจากแพลตฟอร์มของ
            Urbaan ต่อไป
          </p>
          <p className="terms-content__paragraph">
            อนึ่ง
            การละเมิดสิทธิ์ในทรัพย์สินทางปัญญาหมายถึงการขายสินค้าหรือผลิตภัณฑ์ที่เนื้อหาที่มีลิขสิทธิ์หรือที่มีเครื่องหมายการค้าที่จดทะเบียนหรือการออกแบบที่ไม่ได้รับอนุญาตจากเจ้าของทรัพย์สินทางปัญญา
            สามารถสรุปโดยสังเขปได้ดังต่อไปนี้ 1) การละเมิดลิขสิทธิ์ ได้แก่
            การนำผลงานอันมีลิขสิทธิ์ของผู้อื่น มาใช้ ดัดแปลง เผยแพร่ ทำซ้ำ
            ในส่วนของ รูปภาพ แบบแปลน โลโก้ หรือเนื้อหาที่มีลิขสิทธิ์
            รวมถึงแต่ไม่จำกัดเพียง คำอธิบาย คำแนะนำ รายละเอียด สินค้า บริการ
            หรือ ผลิตภัณฑ์ โดยไม่ได้รับอนุญาตจาก
            ผู้เป็นเจ้าของลิขสิทธิ์หรือผู้ทรงสิทธิ 2)การละเมิดสิทธิบัตร ได้แก่
            การขายหรือเสนอขาย
            หรือนำเข้าซึ่งผลิตภัณฑ์ตามสิทธิบัตรหรือผลิตภัณฑ์ที่ใช้กรรมวิธีตามสิทธิบัตร
            หรือผลิตภัณฑ์ที่ใช้การออกแบบโดยไม่ได้รับอนุญาตจากผู้ทรงสิทธิบัตร 3)
            การละเมิดเครื่องหมายการค้าหรือชื่อทางการค้า หมายถึง
            การใช้เครื่องหมายการค้า หรือชื่อทางการค้า เพื่อโฆษณา, อ้างอิง ผ่าน
            ชื่อ รูปภาพ หรือคำอธิบายเนื้อหาสินค้า
            รวมทั้งจำหน่ายสินค้าปลอมแปลงภายใต้เครื่องหมายการค้า
            (รวมถึงมีความคล้ายคลึงกัน) โดยไม่ได้รับอนุญาตจากเจ้าของ รวมถึง
            กรณีการทำให้มีการเข้าใจผิดถึง ความเป็นเจ้าของเครื่องหมายการค้า
          </p>
          <p className="terms-content__paragraph">
            ทั้งนี้ เพื่อให้เข้าใจตรงกันว่า สิทธิในทางทรัพย์สินทางปัญญานั้น
            การจำหน่าย จ่าย โอน อนุมัติ มอบหมายให้ใช้สิทธิใด ๆ
            ก็ตามภายใต้สิทธิในทางทรัพย์สินทางปัญญา
            เป็นอำนาจแต่เพียงผู้เดียวผู้ทรงสิทธิในทรัพย์สินทางปัญญาเท่านั้น
            Urbaan ไม่มีหน้าที่ในการให้ความช่วยเหลือหรือดำเนินการใด ๆ
            เกี่ยวกับการดังกล่าว
          </p>
          <p className="terms-content__heading">
            9. การรายงานการละเมิดสิทธิ์ในทรัพย์สินทางปัญญา
          </p>
          <p className="terms-content__paragraph">
            9.1 Urbaan ไม่อนุญาตให้มีการลงสินค้า หรือ รายละเอียดเนื้อหาใด ๆ
            ที่ละเมิดสิทธิในทรัพย์สินทางปัญญาของเจ้าของสิทธิในทรัพย์สินทางปัญญาอื่น
            ๆ (“เจ้าของทรัพย์สินทางปัญญา”)
          </p>
          <p className="terms-content__paragraph">
            9.2 Urbaan
            มิใช่ตัวแทนหรือผู้แทนของผู้ใช้และมิได้ครอบครองและ/หรือเป็นเจ้าของสินค้าใด
            ๆ ที่ลงรายการไว้บนแพลตฟอร์ม
            ผู้ใช้เป็นปัจเจกบุคคลหรือหรือองค์กรธุรกิจที่เป็นอิสระและไม่มีความเกี่ยวข้องกับ
            Urbaan ไม่ว่าในทางใด ยกเว้นในกรณีที่ระบุไว้ชัดแจ้งเป็นอย่างอื่น
          </p>
          <p className="terms-content__paragraph">
            9.3 Urbaan ไม่มีหน้าที่ในการให้ความช่วยเหลือหรือดำเนินการใด ๆ
            ในการบังคับใช้ข้อตกลงการจัดจำหน่ายสินค้าแต่เพียงผู้เดียว
            หรือมาตรการในการควบคุมราคาสินค้าใด ๆ
            เว้นแต่กรณีที่เป็นข้อกำหนดของกฎหมายและUrbaan รับทราบว่า
            ภายใต้กฎหมายที่ใช้บังคับ
            แบรนด์หรือผู้ผลิตสินค้าอาจมีสิทธิในการเข้าทำสัญญาว่าด้วยการจัดจำหน่ายสินค้าแต่เพียงผู้เดียว
            หรือสัญญาที่กำหนดราคาขายขั้นต่ำสำหรับสินค้าของตนหรือของบุคคลภายนอก
            อย่างไรก็ตาม
            การละเมิดสัญญาในลักษณะดังกล่าวไม่ถือเป็นการละเมิดสิทธิในทรัพย์สินทางปัญญา
            โดยการบังคับตามสัญญาดังกล่าวเป็นเรื่องระหว่างแบรนด์หรือผู้ผลิตสินค้ากับบุคคลภายนอกที่เป็นคู่สัญญา
          </p>
          <p className="terms-content__paragraph">
            9.4 โดยไม่เป็นการจำกัดการชดใช้ค่าเสียหายตามข้อ 20
            ผู้ขายแต่ละรายและทุกรายตกลงที่จะชดใช้ค่าเสียหายและไม่ให้ Urbaan และ
            บริษัท ในเครือ รับผิดชอบในข้อเรียกร้องการกระทำ ความเสียหาย
            และการพิจารณาตัดสินใด ๆ ทั้งหมด อันเกิดขึ้นจาก หรือเกี่ยวข้องกับ (1)
            การเรียกร้อง ข้อร้องเรียน หรือการละเมิดในทรัพย์สินทางปัญญาใด ๆ
            ที่เกี่ยวข้องกับเนื้อหาหรือรายการผลิตภัณฑ์ และ/หรือ (2)
            การนำเนื้อหาหรือรายการสินค้าหรือบริการใด ๆ ออก
            อันเกิดจากการเรียกร้อง ข้อร้องเรียน หรือการละเมิดทรัพย์สินทางปัญญาใด
            ๆ
          </p>
          <p className="terms-content__paragraph">
            9.5 หากท่านประสงค์จะแจ้งการร้องเรียนสินค้าละเมิดทรัพย์สินทางปัญญา
            โปรดติดต่อ admin@urbaancommunities.com
            พร้อมจัดเตรียมเอกสารดังต่อไปนี้ ก) กรณีละเมิดลิขสิทธิ ให้เตรียม 1.
            รูปภาพต้นฉบับ (มีลายน้ำ) 2.
            ลิงก์สินค้าหรือหลักฐานอื่นๆ ที่บ่งบอกถึงการเป็นเจ้าของผลงาน เช่น
            เว็บแพลตฟอร์มที่ลงรูปภาพต้นฉบับ ข)
            ละเมิดสิทธิบัตรการออกแบบหรือสิทธิบัตรสิ่งประดิษฐ์ ให้เตรียม 1.
            หนังสือมอบอำนาจ (กรณีเป็นตัวแทนจำหน่าย / ตัวแทนผู้ร้องเรียน) 2.
            หนังสือสำคัญแสดงการจดทะเบียนสิทธิบัตรการออกแบบผลิตภัณฑ์หรือสิทธิบัตรสิ่งประดิษฐ์
            3. รูปภาพและข้อมูลเพิ่มเติมเกี่ยวกับสินค้าหรือผลิตภัณฑ์ ค)
            ละเมิดเครื่องหมายการค้า ให้เตรียม 1. หนังสือมอบอำนาจ
            (กรณีเป็นตัวแทนจำหน่าย / ตัวแทนผู้ร้องเรียน) 2.
            หนังสือสำคัญแสดงการจดทะเบียนเครื่องหมายการค้า 3.
            รูปภาพและข้อมูลเพิ่มเติมเกี่ยวกับสินค้าหรือผลิตภัณฑ์
          </p>
          <p className="terms-content__heading">
            10. การสั่งซื้อและการชำระเงิน
          </p>
          <p className="terms-content__paragraph">
            10.1 Urbaan สงวนสิทธิแต่เพียงผู้เดียวที่จะแก้ไข ระงับ หรือยกเลิก
            และ/หรือ กำหนดเงื่อนไขใด ๆ รวมถึงแต่ไม่จำกัดเพียงกำหนดมูลค่าขั้นต่ำ
            สำหรับวิธีการชำระเงินประเภทใด ๆ Urbaan
            อาจจัดให้มีการชำระเงินด้วยวิธีการต่าง ๆ
            รวมถึงวิธีการซึ่งระบุไว้ต่อไปนี้
          </p>
          <p className="terms-content__sub-paragraph">
            10.1.1 การโอนเงินผ่านธนาคาร QR พร้อมเพย์
            ผู้ซื้อสามารถชำระเงินด้วยวิธีการโอนเงินผ่าน QR พร้อมเพย์
            โดยระบบจะแสดงรูปภาพคิวอาร์โค้ดขึ้นมาเพื่อให้ผู้ซื้อสามารถบันทึกรูปภาพและนำไปสแกนจ่ายในแอปพลิเคชันธนาคารของผู้ซื้อ
          </p>
          <p className="terms-content__sub-paragraph">
            10.1.2 บัตรเครดิต
            การชำระผ่านบัตรเครดิตจะดำเนินการผ่านช่องทางการชำระเงินของบุคคลภายนอก
            และชนิดของบัตรเครดิตที่ช่องทางการชำระเงินเหล่านี้ยอมรับอาจแตกต่างกันไปตามเขตอำนาจตามกฎหมายที่ท่านอยู่
          </p>
          <p className="terms-content__sub-paragraph">
            10.1.3 การชำระผ่าน Mobile Banking
            ผู้ซื้อสามารถชำระเงินโดยการทำธุรกรรมผ่านแอปพลิเคชันของธนาคารที่รองรับซึ่งผู้ซื้อได้ลงทะเบียนเพื่อใช้บริการทางการเงินไว้
          </p>
          <p className="terms-content__sub-paragraph">
            10.1.4 การชำระผ่าน Wallet ต่างๆ
            ผู้ซื้อสามารถชำระเงินโดยการทำธุรกรรมผ่านแอปพลิเคชันของผู้ให้บริการที่รองรับโดย
            Urbaan
          </p>
          <p className="terms-content__paragraph">
            10.2
            ผู้ซื้อสามารถเปลี่ยนวิธีการชำระเงินที่ต้องการได้ต่อเมื่อเปลี่ยนก่อนทำการชำระเงินเท่านั้น
            Urbaan ไม่หน้าที่หรือความรับผิดใด ๆ
            หากผู้ซื้อมีความประสงค์ดำเนินการเปลี่ยนวิธีการชำระเงินภายหลัง
          </p>
          <p className="terms-content__paragraph">
            10.3 Urbaan ไม่มีหน้าที่รับผิดชอบ
            ต่อความความเสียหายหรือสูญเสียใดๆก็ตาม
            ที่เกิดแก่ผู้ซื้ออันเกิดจากข้อมูลส่วนตัวและ/หรือข้อมูลการชำระเงินที่ผู้ซื้อป้อนไว้
            หรือการที่ผู้ซื้อโอนเงินค่าชำระสินค้าหรือบริการที่ซื้อไม่ถูกต้อง
            Urbaan
            ขอสงวนสิทธิ์ในการตรวจสอบว่าผู้ซื้อได้รับอนุญาตอย่างเหมาะสมให้ใช้วิธีการชำระเงินบางอย่าง
            และอาจใช้ดุลยพินิจแต่เพียงผู้เดียวในการดำเนินการระงับธุรกรรมไว้จนกว่าจะได้ยืนยันการอนุญาตนั้นแล้ว
            หรือยกเลิกธุรกรรมที่เกี่ยวข้องกรณีไม่มีการยืนยันดังกล่าว
          </p>
          <p className="terms-content__paragraph">
            10.4 ในกรณีที่ Urbaan
            สามารถชำระเงินแก่ผู้ใช้ทางการโอนเงินผ่านธนาคารเท่านั้น
            ผู้ใช้จำเป็นต้องให้ข้อมูลบัญชีเงินฝากของตนแก่ Urbaan
            เพื่อรับการชำระเงิน กล่าวคือ จากการขายสินค้า บริการ
            หรือการคืนเงินจาก Urbaan
          </p>
          <p className="terms-content__heading">11. URBAAN SELLER BALANCE</p>
          <p className="terms-content__paragraph">
            11.1 Urbaan Seller Balance เป็นส่วนหนึ่งของบริการของ Urbaan
            สำหรับแสดงยอดเงินรับคงเหลือ (Balance)
            ที่ผู้ขายมีสิทธิจะได้รับจากเงินค่าสินค้าหรือบริการภายใต้ข้อกำหนดและเงื่อนไขตามที่กำหนดไว้ในเงื่อนไขการให้บริการนี้
            ซึ่งอาจรวมถึงเงินคืนจากค่าขายสินค้า ค่าบริการ หรือเงินคืนใด ๆ
            (ถ้ามี)
          </p>
          <p className="terms-content__paragraph">
            11.2 เพื่อคุ้มครองผู้ซื้อและป้องกันความเสี่ยงจากการรับผิด Urbaan
            จะเก็บเงินค่าสินค้าหรือบริการ
            ที่ผู้ซื้อได้ชำระไว้ในบัญชีแยกต่างหากจากบัญชีเงินทุนของบริษัทหรือของตัวแทนที่ได้รับมอบหมายโดยบริษัท
            โดยผู้ขายจะไม่มีสิทธิได้รับผลประโยชน์หรือผลตอบแทนอื่นใดจากจำนวนเงินที่ผู้ซื้อได้ชำระไปยังบัญชีดังกล่าว
            ทั้งนี้ เงินค่าสินค้าหรือที่ถูกเก็บไว้ในบัญชีดังกล่าว
            จะถูกแสดงเป็นจำนวนยอดเงินรับคงเหลือ (Balance) ใน Urbaan Seller
            Balance ภายในหนึ่ง (1)
            วันหลังจากที่พ้นระยะเวลาตามเงื่อนไขที่กำหนดไว้ต่อไปนี้
            (“ระยะเวลาในการได้รับเงินค่าสินค้าหรือบริการ”)
          </p>
          <p className="terms-content__sub-paragraph">
            (1) เมื่อผู้ซื้อส่งคำยืนยันไปยัง Urbaan
            ว่าผู้ซื้อได้รับสินค้าหรือบริการตามคำสั่งซื้อแล้ว หรือเจ็ด (5)
            วันทำการ นับจากวันที่สินค้าหรือบริการได้ถูกส่งมอบให้แก่ผู้ซื้อ
            แล้วแต่กรณีใดจะเกิดขึ้นก่อน เว้นแต่กรณีที่ Urbaan
            ได้พิจารณาตามดุลยพินิจของตนแต่เพียงผู้เดียวขยายเวลาดังกล่าวออกไปเพื่อความเหมาะสมหรือตามความจำเป็นภายใต้เงื่อนไขที่กำหนดโดย
            Urbaan ทั้งนี้ โดยการแจ้งให้ผู้ขายทราบล่วงหน้าตามสมควร หรือ
          </p>
          <p className="terms-content__sub-paragraph">
            (2) เมื่อ Urbaan
            พิจารณาคำร้องขอคืนสินค้าหรือบริการและ/หรือคืนเงินค่าสินค้าหรือบริการของผู้ซื้อเสร็จสิ้น
            และได้ปฏิเสธคำร้องขอดังกล่าว หรือ
          </p>
          <p className="terms-content__sub-paragraph">
            (3) เวลาอื่นที่ Urbaan
            พิจารณาอย่างสมเหตุสมผลแล้วว่าการโอนเงินค่าสินค้าหรือบริการนั้นเหมาะสม
            รวมถึงแต่ไม่จำกัดเพียงกรณีที่ Urbaan
            เห็นสมควรว่าจำเป็นจะต้องปฏิบัติตามกฎหมายที่บังคับใช้ หรือคำสั่งศาล
            หรือเพื่อบังคับใช้เงื่อนไขการให้บริการนี้
          </p>
          <p className="terms-content__paragraph">
            11.3 ยอดเงินรับคงเหลือ (Balance) ที่แสดงอยู่ใน Urbaan Seller Balance
            จะเป็นจำนวนยอดเงินรับคงเหลือ หลังจากหักเงินค่าธรรมเนียมบริการใด ๆ
            และ/หรือ เงินเรียกเก็บอื่นใด หรือหลังคืนค่าส่วนลด และ/หรือ
            เงินคืนอื่นใด ที่เกี่ยวข้องกับการใช้บริการของ Urbaan โดย Urbaan
            หรือตัวแทนที่ได้รับอนุญาต
            ตามเงื่อนไขที่กำหนดไว้ในเงื่อนไขการให้บริการ และนโยบายใดๆ ของ Urbaan
            หรือตามที่ผู้ขายได้ตกลงหรือรับทราบผ่านแพลตฟอร์มนี้
          </p>
          <p className="terms-content__paragraph">
            11.4 เพื่อมิให้มีข้อสงสัย ในบางกรณียอดเงินรับคงเหลือ (Balance) ใน
            Urbaan Seller Balance ของผู้ขายอาจมีการแสดงรายการเป็นลบ
            และผู้ขายจะไม่สามารถถอนเงินจากยอดเงินรับคงเหลือ (Balance)
            ที่แสดงอยู่ใน Urbaan Seller Balance ได้ จนกว่ายอดเงินรับคงเหลือ
            (Balance) จะแสดงเป็นบวก
          </p>
          <p className="terms-content__paragraph">
            11.5 Urbaan Seller Balance
            ไม่ใช่การให้บริการกระเป๋าเงินอิเล็กทรอนิกส์ (E-Wallet) แก่ผู้ขาย
            ผู้ขายไม่สามารถใช้ Urbaan Seller Balance
            เพื่อเป็นช่องทางในการชำระค่าสินค้า และ/หรือ บริการได้
            หรือดำเนินการอื่นใดเกี่ยวกับยอดเงินรับคงเหลือ (Balance)
            ที่แสดงอยู่ใน Urbaan Seller Balance
            นอกเหนือไปจากการถอนเงินภายใต้ข้อกำหนดและเงื่อนไขที่ตามกำหนดไว้ในข้อ
            11 ของเงื่อนไขการให้บริการ
          </p>
          <p className="terms-content__paragraph">
            11.6 ในกรณีที่บัญชีของท่านถูกยกเลิก เพิกถอน หรือระงับ
            โดยเป็นไปตามเงื่อนไขการให้บริการนี้
            หรือในกรณีที่บัญชีของท่านไม่มีการใช้งาน ตามระยะเวลาที่ Urbaan
            อาจกำหนดเป็นครั้งคราว Urbaan
            มีสิทธิในการเรียกเก็บค่าธรรมเนียมในการบริหารจัดการยอดเงินที่คงเหลือที่แสดงอยู่ใน
            Seller Balance ในบัญชีของท่าน
            โดยจำนวนและกำหนดเวลาในการเรียกเก็บค่าธรรมเนียมดังกล่าวจะเป็นไปตามที่
            Urbaan อาจกำหนดเป็นครั้งคราว
          </p>
          <p className="terms-content__heading">
            12. การถอนเงินและการปรับมูลค่าคงเหลือ
          </p>
          <p className="terms-content__paragraph">
            12.1 ท่านสามารถถอนเงินจากยอดเงินรับคงเหลือ (Balance) ที่แสดงอยู่ใน
            Urbaan Seller Balance ของท่าน ตามจำนวนที่เท่าที่ Urbaan กำหนด
            ไปยังบัญชีธนาคารที่ได้ผูกไว้ โดยยื่นคำสั่งขอถอนเงิน (“คำขอถอนเงิน”)
            ให้แก่ Urbaan ทั้งนี้ Urbaan อาจทำการโอนเงินจากยอดเงินรับคงเหลือ
            (Balance) ที่แสดงอยู่ใน Urbaan Seller Balance
            ไปยังบัญชีที่ได้ผูกไว้โดยอัตโนมัติ ตามระยะเวลาที่ Urbaan เห็นสมควร
            Urbaan
            จะดำเนินการโอนเงินดังกล่าวในวันทำการและการโอนเงินอาจใช้เวลาไม่เกิน 7
            วันทำการก่อนที่จะเข้าบัญชีที่ได้ผูกไว้
          </p>
          <p className="terms-content__paragraph">
            12.2
            ท่านไม่สามารถเปลี่ยนแปลงหรือยกเลิกคำขอถอนเงินหลังจากที่ได้ยื่นคำขอถอนเงินดังกล่าวแล้ว
          </p>
          <p className="terms-content__paragraph">
            12.3 หากเกิดข้อผิดพลาดในการดำเนินธุรกรรมใด ๆ ท่านอนุญาตให้ Urbaan
            ทำการแก้ไขปรับปรุงรายการโดยการหักเงิน (เดบิต) จากหรือคืนเงิน
            (เครดิต) ไปยังบัญชีธนาคารที่ท่านกำหนดเพื่อแก้ไขความผิดพลาดดังกล่าว
            ทั้งนี้
            การแก้ไขปรับปรุงจะต้องเป็นตามกฎหมายและกฎเกณฑ์ที่มีผลบังคับใช้ หาก
            Urbaan ไม่สามารถทำการหักเงินจากบัญชีธนาคารของท่านได้ ไม่ว่ากรณีใด ๆ
            ท่านอนุญาตให้ Urbaan หักเงินรวมถึงค่าธรรมเนียมใด ๆ
            จากบัญชีธนาคารหรือตราสารการจ่ายเงินอื่นใดที่ท่านได้แจ้งไว้ต่อ Urbaan
            หรือให้หักเงินและค่าธรรมเนียมใด ๆ ออกจากยอดเงินรับคงเหลือ (Balance)
            ที่แสดงอยู่ใน Urbaan Seller Balance ของท่านได้ในอนาคต
          </p>
          <p className="terms-content__paragraph">
            12.4 ท่านยินยอมให้ Urbaan หักเงินจากบัญชี หรือบัญชีธนาคารของท่าน
            ตามยอดเงินรับคงเหลือ (Balance) ที่แสดงอยู่ใน Urbaan Seller Balance
            ของท่าน (แล้วแต่กรณี) ในกรณีดังต่อไปนี้
          </p>
          <p className="terms-content__sub-paragraph">
            (1) เพื่อทำการแก้ไขความผิดพลาดในการดำเนินธุรกรรมใดๆ
          </p>
          <p className="terms-content__sub-paragraph">
            (2) เมื่อ Urbaan
            เห็นว่าท่านได้กระทำการหรือดำเนินธุรกรรมอันเป็นการฉ้อโกงหรือเป็นที่ต้องสงสัย
          </p>
          <p className="terms-content__sub-paragraph">
            (3) กรณีที่เกี่ยวข้องกับการสูญหาย ความเสียหายหรือความผิดพลาดใดๆ
            ต่อสินค้าหรือบริการ
          </p>
          <p className="terms-content__sub-paragraph">
            (4) กรณีที่เกี่ยวข้องกับค่าใช้จ่ายใด ๆ
            สินค้าที่เกี่ยวข้องกับสินค้าหรือบริการ
          </p>
          <p className="terms-content__sub-paragraph">
            (5)
            กรณีที่เกี่ยวข้องกับการคืนเงินค่าสินค้าให้แก่ผู้ซื้อซึ่งได้ยื่นคำขอคืนสินค้าและ/หรือคืนเงินภายหลังจากที่เงินค่าสินค้าได้แสดงเป็นจำนวนยอดเงินรับคงเหลือ
            (Balance) ใน Urbaan Seller Balance ของผู้ขายแล้วตามข้อ 11
          </p>
          <p className="terms-content__sub-paragraph">
            (6) กรณีที่เกี่ยวข้องกับค่าธรรมเนียมที่ไม่ได้เรียกเก็บ
            หรือท่านได้ค้างจ่ายค่าธรรมเนียมหรือค่าใช้จ่ายอื่นใดต่อ Urbaan
            หรือในกรณีที่ Urbaan
            ยังไม่สามารถเรียกเก็บค่าธรรมเนียมหรือค่าใช้จ่ายดังกล่าวได้จากช่องทางอื่น
          </p>
          <p className="terms-content__sub-paragraph">
            (7) กรณีที่เกี่ยวข้องกับการประนีประนอมข้อพิพาททางธุรกรรมใดๆ
            รวมถึงค่าชดเชยที่ Urbaan ต้องชดเชยให้ท่านหรือที่ท่านต้องชดเชยให้
            Urbaan
          </p>
          <p className="terms-content__sub-paragraph">
            (8) กรณีที่เกี่ยวข้องกับค่าเสียหาย และ/หรือ
            ข้อตกลงในการประนีประนอมข้อพิพาท ไม่ว่าภายในหรือภายนอกศาล
            ค่าปรับทางอาญา ค่าปรับทางปกครอง ค่าปรับ ต้นทุน และ/หรือ
            ค่าใช้จ่ายใดๆ ที่เกิดขึ้นกับ Urbaan
            อันมีเหตุมาจากความผิดของผู้ซื้อหรือผู้ขาย และ/หรือ
            การละเมิดของผู้ซื้อหรือผู้ขาย ซึ่งรวมถึงการละเมิดข้อตกลงใดๆ
            ภายใต้เงื่อนไขการให้บริการนี้ และ/หรือ กฎหมายและข้อบังคับใดๆ
          </p>
          <p className="terms-content__sub-paragraph">
            (9)
            กรณีที่เกี่ยวข้องกับการเปลี่ยนข้อตกลงที่ได้ตกลงกันแล้วระหว่างผู้ซื้อและผู้ขาย
          </p>
          <p className="terms-content__sub-paragraph">
            (10)
            กรณีที่เกี่ยวข้องกับการซื้อเครดิตโฆษณาภายใต้การเติมเงินเครดิตโฆษณาแบบอัตโนมัติ
            และ
          </p>
          <p className="terms-content__sub-paragraph">
            (11) กรณีอื่นใดที่ Urbaan เห็นสมควร
          </p>
          <p className="terms-content__heading">
            13. การตรวจรับสินค้าหรือบริการ และ การอำนวยความสะดวกของ Urbaan
          </p>
          <p className="terms-content__paragraph">
            13.1 เว้นแต่ได้มีการระบุไว้เป็นอย่างอื่นภายใต้แพลตฟอร์มนี้
            การซื้อขายสินค้าและบริการภายหลังจากที่ผู้ซื้อได้ชำระเงินค่าสินค้าหรือบริการ
            ผู้ซื้อมีหน้าที่ตรวจสอบสินค้าหรือบริการว่าถูกต้อง
            ตามคำสั่งซื้อของผู้ซื้อหรือไม่ รวมถึงแต่ไม่จำกัดเพียง
            สัญญาก่อสร้างที่ผู้รับจ้างและผู้ว่าจ้างตกลงกันเข้าสัญญานั้น
            เมื่อผู้ว่าจ้างได้โอนชำระเงินค่าจ้างให้ผู้รับจ้างผ่านทางแพลตฟอร์ม
            ก่อนที่แพลตฟอร์มจะโอนเงินชำระค่าจ้างในแต่ละงวดให้ผู้รับจ้าง
            ผู้ว่าจ้างมีหน้าที่ตรวจสอบว่าผู้รับจ้างดำเนินการก่อสร้างถูกต้องตามกำหนดในแต่ละงวดงานตามที่ได้ตกลงกันไว้ในสัญญา
            จึงอนุมัติรับมอบงานก่อสร้างแต่ละงวด
            เมื่อได้ทำการอนุมัติรับมอบงานแล้วผู้ว่าจ้างจะมีหน้าที่แจ้งการอนุมัติดังกล่าวมายังแพลตฟอร์ม
            แพลตฟอร์มจึงจะดำเนินการโอนเงินค่าจ้างจากแพลตฟอร์มให้ผู้รับจ้าง
            หรือในกรณีที่ดำเนินการซื้อแบบ สามมิติ Autocad ไฟล์ดิจิตอลต่าง ๆ
            ผู้ซื้อมีหน้าที่ตรวจสอบความถูกต้องของสินค้าหรือบริการ
            ว่าไม่มีความชำรุดบกพร่องใด ๆ และเป็นไปตามคำสั่งซื้อของผู้ซื้อ
            เมื่อผู้ซื้อทำการตรวจสอบสินค้าหรือบริการแล้วมีหน้าที่แจ้งมายังแพลตฟอร์มเพื่อดำเนินการโอนเงินค่าสินค้าหรือบริการให้แก่ผู้ขาย
            ทั้งนี้ในขั้นตอนการตรวจรับมอบงาน หรือ
            การตรวจรับสินค้าหรือบริการข้างต้น
            หากทางผู้ซื้อหรือผู้ว่าจ้างมีข้อสงสัยประการใดในการตรวจรับงาน สินค้า
            หรือบริการ
          </p>
          <p className="terms-content__paragraph">
            13.2 อนึ่ง Urbaan ยินดีที่จะช่วยอำนวยความสะดวกโดยในการให้คำปรึกษาว่า
            ความสำเร็จของงานก่อสร้างในแต่ละงวดถูกต้องตามที่ผู้ว่าจ้างและผู้รับจ้างได้ตกลงกันไว้ในสัญญา
            หรือ ตรวจสอบความถูกต้องของสินค้าหรือบริการ
          </p>
          <p className="terms-content__paragraph">
            13.3
            กรณีการอำนวนความสะดวกมีวัตถุประสงค์เพื่อคุ้มครองผู้ซื้อที่ซื้อสินค้าหรือบริการบนแพลตฟอร์มของ
            Urbaan และ ได้ชำระเงินผ่านช่องทางที่จัดไว้ให้โดย Urbaan เท่านั้น
            การดำเนินการชำระเงินค่าสินค้าโดยวิธีการอื่นระหว่างผู้ซื้อและผู้ขายเอง
            Urbaan จะไม่มีส่วนเกี่ยวข้อง
          </p>
          <p className="terms-content__paragraph">
            13.4 ผู้ซื้อที่ได้ชำระเงินผ่านช่องทางที่จัดไว้ให้โดย Urbaan
            จะมีสิทธิยื่นคำร้องขอคืนสินค้าหรือบริการที่ซื้อ
            และ/หรือคืนเงินค่าสินค้าหรือบริการในกรณีที่สินค้า มีความชำรุดบกพร่อง
            ภายในระยะเวลา 7 วันทำการหลังทำการชำระเงิน ตามการพิจารณาที่กำหนดโดย
            Urbaan สำหรับสินค้าหรือบริการแต่ละประเภท
          </p>
          <p className="terms-content__paragraph">
            13.5
            ผู้ซื้อหรือผู้ขายจะต้องเป็นผู้รับผลประโยชน์ของบัญชีและทำธุรกรรมบนแพลตฟอร์มในนามของตัวเองเท่านั้น
            Urbaan อาจขอข้อมูลส่วนบุคคลของผู้ขายหรือผู้ซื้อ เช่น
            สำเนาบัตรประชาชน รายละเอียดบัญชีธนาคารและ/หรือเอกสารอื่นใดที่จำเป็น
            เพื่อใช้ในการตรวจสอบซึ่งรวมถึงการตรวจสอบที่จำเป็นโดยผู้ให้บริการดำเนินการชำระเงินและผู้ให้บริการจัดส่งสินค้ารายอื่น
            ผู้ขาย/ผู้ซื้อยินยอมให้ Urbaan
            ใช้หรือให้บุคคลภายนอกซึ่งข้อมูลส่วนบุคคลของผู้ขาย/ผู้ซื้อเพื่ออำนวยความสะดวกในการใช้แพลตฟอร์มของผู้ขาย/ผู้ซื้อ
            นอกจากนี้ผู้ขาย/ผู้ซื้ออนุญาตให้ Urbaan
            ใช้ข้อมูลส่วนบุคคลของผู้ขาย/ผู้ซื้อเพื่อทำการซักถามที่Urbaanพิจารณาว่าจำเป็นต่อการตรวจสอบความถูกต้องของข้อมูลประจำตัวของผู้ขาย/ผู้ซื้อกับหน่วยงานที่เหมาะสม
            เช่น ธนาคารของผู้ขาย/ผู้ซื้อ
            สำหรับรายละเอียดเพิ่มเติมเกี่ยวกับวิธีการที่ Urbaan
            ดำเนินการกับข้อมูลส่วนบุคคลของท่าน
            โปรดพิจาราณา[ข้อกำหนดความเป็นส่วนตัว]
          </p>
          <p className="terms-content__paragraph">
            13.6
            การอำนวยความสะดวกนี้เป็นบริการเสริมซึ่งแยกต่างหากจากข้อผูกพันระหว่างผู้ซื้อและผู้ขายภายใต้กฎหมายที่เกี่ยวข้อง
            ซึ่งในข้อผูกพันนั้น
            ผู้ซื้อและผู้ขายอาจมีสิทธิและหน้าที่่ระหว่างกันมากกว่าที่กำหนดไว้ใน
            ข้อ 13
            ไม่ได้มีจุดมุ่งหมายหรือออกแบบมาเพื่อช่วยผู้ซื้อหรือผู้ขายในการปฏิบัติตามข้อผูกพันตามกฎหมายของตัวเอง
            ซึ่งคู่สัญญาแต่ละฝ่ายจะยังคงรับผิดชอบแต่เพียงผู้เดียว และ Urbaan
            จะไม่รับผิดจากกรณีดังกล่าว โดยไม่มีข้อจำกัด
            การช่วยอำนวยความสะดวกนี้ไม่ถือเป็นการรับประกันสินค้า
            การรับประกันการบริการหรือการรับประกันผลิตภัณฑ์
          </p>
          <p className="terms-content__paragraph">
            13.7 ผู้ซื้อและผู้ขายรับทราบและตกลงว่าการตัดสินใจของ Urbaan
            ที่เกี่ยวกับหรือเกี่ยวเนื่องกับประเด็นใดที่เกี่ยวข้องกับการอำนวยความสะดวกนี้
            ถือเป็นที่สิ้นสุด
          </p>
          <p className="terms-content__paragraph">
            13.8 ธุรกรรมใด ๆ
            ที่ไม่ได้ทำผ่านทางแพลตฟอร์มจะไม่ได้รับการอำนวยความสะดวกความคุ้มครองใด
            ๆ จาก Urbaan
          </p>
          <p className="terms-content__heading">
            14. การยกเลิกการซื้อสินค้าและบริการ
          </p>
          <p className="terms-content__paragraph">
            14.1 เว้นแต่กำหนดไว้โดยชัดแจ้ง
            ผู้ซื้อสามารถยกเลิกคำสั่งซื้อได้ก่อนที่ผู้ซื้อจะชำระเงินเท่านั้น
          </p>
          <p className="terms-content__paragraph">
            14.2
            เว้นแต่กำหนดไว้โดยชัดแจ้งผู้ซื้อสามารถยื่นคำร้องขอให้คืนสินค้าที่ซื้อและคืนเงินค่าสินค้าของผู้ซื้อก่อนวันหมดระยะเวลาการตรวจรับสินค้าหรือบริการเท่านั้น
            ถ้าเหมาะสม โดยเป็นไปตามเงื่อนไขการคืนเงินและคืนสินค้าของ Urbaan
          </p>
          <p className="terms-content__paragraph">
            14.3 Urbaan
            สงวนสิทธิ์แต่เพียงผู้เดียวในการยกเลิกธุรกรรมบนแพลตฟอร์มและผู้ซื้อรับทราบและตกลงว่าการเยียวยาความเสียหายแก่ผู้ซื้อมีอย่างเดียวคือการได้รับการคืนเงินค่าสินค้าที่ผู้ซื้อได้ชำระไว้เท่านั้น
          </p>
          <p className="terms-content__paragraph">
            14.4 ในกรณีที่มีการยกเลิกการคืนสินค้าและการคืนเงิน ท่านตกลงให้
            Urbaan
            หรือตัวแทนที่ได้รับอนุญาตทำการคืนเงินค่าสินค้าของผู้ซื้อหรือค่าธรรมเนียมอื่นใด
            ผ่านทางช่องทางที่ Urbaan กำหนดหรือบัญชีธนาคารของท่าน เท่านั้น
          </p>
          <p className="terms-content__heading">
            15 ความรับผิดชอบของผู้ขายสินค้าและบริการ
          </p>
          <p className="terms-content__paragraph">
            15.1 ผู้ขายควรตรวจสอบและจัดการอย่างเหมาะสมว่าสินค้าและบริการ เช่น
            ราคาและรายละเอียดสินค้าหรือบริการ จำนวนสินค้าในคลัง
            และข้อกำหนดและเงื่อนไขในการขายให้ได้รับการทำให้เป็นปัจจุบันในบัญชีรายการสินค้าและบริการของผู้ขาย
            และไม่แสดงข้อมูลที่ไม่ทำให้เข้าใจผิดหรือไม่ถูกต้อง
          </p>
          <p className="terms-content__paragraph">
            15.2 ราคาสินค้าหรือบริการที่ขายนั้นจะกำหนดโดยผู้ขายเอง
            จำนวนเงินทั้งหมดที่จะเรียกเก็บกับผู้ซื้อจะรวมราคาสินค้า ค่าจัดส่ง
            และค่าใช้จ่ายอื่นใดที่เกิดขึ้น เช่น ภาษีและค่าธรรมเนียมที่เกี่ยวข้อง
            เป็นต้น
            และผู้ขายจะไม่เรียกเก็บเงินดังกล่าวจากผู้ซื้อเพิ่มเติมและแยกต่างหาก
          </p>
          <p className="terms-content__paragraph">
            15.3 ผู้ขายตกลงว่า Urbaan มีสิทธิจัดกิจกรรมส่งเสริมการขาย
            เพื่อกระตุ้นการทำธุรกรรมระหว่างผู้ซื้อและผู้ขายและธุรกรรมอื่นๆ
            บนแพลตฟอร์ม รวมถึงแต่ไม่จำกัดเพียงการลดราคา ให้ส่วนลดราคา
            หรือคืนเงินค่าธรรมเนียมที่ได้จ่ายไปหรือด้วยวิธีการอื่นใด
            ตามดุลพินิจแต่เพียงผู้เดียวของ Urbaan ทั้งนี้ Urbaan
            อาจเรียกเก็บค่าใช้จ่ายทั้งหมดหรือแต่บางส่วนในการจัดกิจกรรมส่งเสริมการขายหรือค่าธรรมเนียมการเข้าร่วมกิจกรรมส่งเสริมการขายจากผู้ขาย
            ซึ่ง Urbaan
            จะแจ้งเงื่อนไขสำหรับกิจกรรมส่งเสริมการขายในแต่ละคราวให้ผู้ขายทราบโดยหากผู้ขายไม่ประสงค์จะเข้าร่วมกิจกรรมดังกล่าว
            ผู้ขายมีหน้าที่ต้องแจ้งยกเลิกการเข้าร่วมกิจกรรมส่งเสริมการขายต่อ
            Urbaan
            เป็นลายลักษณ์อักษรภายในระยะเวลาทดลองเข้าร่วมกิจกรรมส่งเสริมการขายหรือภายในระยะเวลาที่
            Urbaan กำหนด มิฉะนั้น
            จะถือว่าผู้ขายตกลงยินยอมที่จะปฏิบัติตามเงื่อนไข
            และวิธีการสำหรับกิจกรรมส่งเสริมการขายนั้น
            รวมไปถึงชำระค่าใช้จ่ายหรือค่าธรรมเนียมการเข้าร่วมกิจกรรมส่งเสริมการขาย
            (หากมี)
          </p>
          <p className="terms-content__paragraph">
            15.4
            เพื่อจุดประสงค์ในการส่งเสริมการขายสินค้าและบริการที่ลงรายการไว้โดยผู้ขาย
            Urbaan อาจแสดงรายการดังกล่าวบนแพลตฟอร์มของบุคคลภายนอก เช่น
            แพลตฟอร์มเปรียบเทียบราคาสินค้าและบริการ รวมถึงแพลตฟอร์มอื่น ๆ
            ทั้งในประเทศหรือต่างประเทศที่ปฏิบัติการโดย Urbaan
          </p>
          <p className="terms-content__paragraph">
            15.5 ผู้ขายจะต้องออกสลิปบัตรเครดิต (Credit Card Slip) ใบเสร็จรับเงิน
            (Receipt) หรือใบกำกับภาษี (Invoice) ให้แก่ผู้ซื้อเมื่อมีการร้องขอ
          </p>
          <p className="terms-content__paragraph">
            15.6 ผู้ขายรับทราบและตกลงว่าผู้ซื้อจะรับผิดชอบการเสียภาษี อากรต่าง ๆ
            และค่าธรรมเนียมกับหน่วยงานราชการทีเกี่ยวข้องทั้งหมดสำหรับสินค้าและบริการที่ได้ขาย
            และ
            ผู้ขายจะปรึกษาผู้เชี่ยวชาญเกี่ยวกับเรื่องดังกล่าวก่อนการขายโดยค่าใช้จ่ายของผู้ขายเอง
          </p>
          <p className="terms-content__paragraph">
            15.7 ผู้ขายรับทราบและตกลงว่าหากผู้ขายละเมิดกฎหมายหรือนโยบายใด ๆ ของ
            Urbaan
            ผู้ขายจะเป็นผู้รับผิดชอบในความเสียหายที่เกิดขึ้นและผู้ขายจะปฏิบัติตามวิธีการที่
            Urbaan กำหนด
          </p>
          <p className="terms-content__heading">
            16. การให้บริการโฆษณาการขายสินค้าและการให้บริการ
          </p>
          <p className="terms-content__paragraph">
            16.1 Urbaan ให้บริการโฆษณาแบบค้นหา ads (Search Ads)
            และ/หรือบริการโฆษณาอื่น ซึ่งรวมถึงบริการโฆษณาแบบแสดง ads (“Display
            Ads”) และบริการโฆษณาแบบบูสท์ ads (“Boost Ads”) (ต่อไปนี้จะเรียกว่า
            “บริการโฆษณา Paid Advertising”) ผ่านบนหน้าเว็บแพลตฟอร์มบริการโฆษณา
            (Paid Advertising Site) แบบต่อเนื่องเป็นประจำ (ongoing basis) และ
            Urbaan อาจโฆษณาการให้บริการโฆษณา Paid Advertising
            บนหน้าเว็บแพลตฟอร์มเครื่องมือด้านการตลาด
            โดยจัดเป็นแพ็คเกจรวมกับเครื่องมือทางการตลาดอื่น ๆ (เช่น
            คูปองส่วนลดสินค้า คูปองส่วนลดร้านค้า และเครดิตโฆษณา เป็นต้น)
            สำหรับแคมเปญการตลาดอันหนึ่งอันใดที่ Urbaan
            เป็นผู้จัดขึ้นเป็นครั้งคราว (“Campaign Package”)
            ผู้ขายสามารถซื้อและติดตามสถานะของคำสั่งซื้อของบริการโฆษณา Paid
            Advertising และ/หรือ Campaign Package ได้
          </p>
          <p className="terms-content__paragraph">
            16.2 Urbaan จะให้บริการโฆษณา Paid Advertising และ Campaign Package
            ภายใต้เงื่อนไขการให้บริการนี้
            และสื่อคำอธิบายอื่นใดที่ได้แสดงไว้บนแพลตฟอร์มนี้
            เว็บแพลตฟอร์มบริการโฆษณา (Paid Advertising Site)
            เว็บแพลตฟอร์มเครื่องมือทางการตลาด (Marketing Tools Site)
            หรือการบอกกล่าวอื่นใดเป็นลายลักษณ์อักษรไปยังผู้ขาย
            (ต่อไปนี้เรียกรวมกันว่า “กฎการให้บริการ”)
            ผู้ขายที่ได้ซื้อบริการโฆษณา Paid Advertising และ/หรือ Campaign
            Package ตกลงผูกพันตามกฎการให้บริการ
            หากท่านไม่ยอมรับที่จะผูกพันตามกฎการให้บริการดังกล่าว
            กรุณาอย่าทำการซื้อบริการโฆษณา Paid Advertising หรือ Campaign Package
          </p>
          <p className="terms-content__paragraph">
            16.3 ในการสั่งซื้อ บริการโฆษณา Paid Advertising และ/หรือ Campaign
            Package
            ท่านจะต้องเป็นผู้ขายที่สามารถซื้อบริการดังกล่าวได้ตามกฎการให้บริการ
            และในขณะที่ท่านซื้อและชำระค่าบริการโฆษณา Paid Advertising และ/หรือ
            Campaign Package บัญชีของท่านจะต้องไม่ถูกระงับอยู่
          </p>
          <p className="terms-content__paragraph">
            16.4 ท่านสามารถสั่งซื้อการบริการ Display Ads ผ่านทางช่องทางให้บริการ
            (Service Channel)
            โดยการตั้งค่าวันโฆษณาและงบสำหรับโฆษณาที่ท่านต้องการ
            หรือติดต่อช่องทางให้การบริการ ทั้งนี้ Urbaan
            จะพยายามอย่างเต็มที่ตามทางปฏิบัติทางการค้าในการดำเนินการตามการสั่งบริการ
            Display Ads ของท่าน แต่ Urbaan ไม่รับประกันว่า (1)
            กำหนดวันที่ผู้ขายตั้งค่าไว้ และ/หรือ (2)
            ยอดการรับชมตามงบประมาณที่ผู้ขายกำหนดไว้จะสามารถเป็นไปโดยสมบูรณ์
            เพื่อปราศจากข้อสงสัย Urbaan สงวนสิทธิ์ในการปฏิเสธการให้บริการ
            Display Ads ที่ท่านสั่ง (ไม่ว่าบางส่วนหรือทั้งหมด)
            ภายใต้ดุลพินิจเด็ดขาดของ Urbaan
            โดยอาจบอกกล่าวหรือไม่บอกกล่าวแก่ผู้ขาย นอกจากนี้ Urbaan
            สงวนสิทธิ์ในการเปลี่ยนแปลงค่าบริการในกรณีที่ผู้ขายขอแก้ไขหรือยกเลิกคำสั่ง
            Display Ads ของท่าน ทั้งนี้ ภายหลังจากที่Urbaanได้ให้บริการโฆษณา
            Display Ads แล้ว Urbaan
            จะเรียกเก็บเงินจากผู้ขายโดยคำนวณจากยอดการรับชมที่ได้รับตามจริง
            และผู้ขายจะต้องชำระเงินตามที่เรียกเก็บตามข้อกำหนดและเงื่อนไขที่ระบุไว้ในใบแจ้งหนี้นั้น
            ข้อมูลการส่งเรียกเก็บหนี้ที่ผู้ขายได้ให้ไว้จะใช้สำหรับใบแจ้งหนี้และใบกำกับภาษีที่ออกสำหรับบริการโฆษณา
            Display Ads ทั้งนี้
            ผู้ขายมีหน้าที่รับผิดชอบในการให้ข้อมูลที่ถูกต้องก่อนการส่งคำสั่งซื้อบริการ
            Display Ads ใดๆ
            หากมีข้อผิดพลาดของข้อมูลสำหรับการแจ้งหนี้ที่ท่านได้ให้ไว้ซึ่งอาจส่งผลกระทบต่อการระบุข้อมูลที่ไม่ถูกต้องลงในใบแจ้งหนี้และใบกำกับภาษี
            จะถือเป็นความรับผิดชอบของผู้ขายเอง โดย Urbaan
            สงวนสิทธิ์ในการปฏิเสธการขอแก้ไขใบแจ้งหนี้อันเนื่องมาจากข้อมูลที่ไม่ถูกต้องที่ได้ให้ไว้โดยผู้ขาย
          </p>
          <p className="terms-content__paragraph">
            16.5 ท่านสามารถซื้อบริการโฆษณา Search Ads, Boost Ads and Discovery
            Ads ได้โดยการซื้อเครดิตโฆษณาจาก หน้าเว็บแพลตฟอร์มบริการโฆษณา Paid
            Advertising หรือแพลตฟอร์มอื่นใด (“เครดิตโฆษณา”)
            และค่าธรรมเนียมสำหรับบริการโฆษณา Search Ads and Discovery Ads
            จะชำระโดยหักออกจาก เครดิตโฆษณา (Advertising Credits)
            ตามจำนวนคลิกเข้าชมโฆษณาตามที่ Urbaan กำหนด
            ซึ่งเครดิตการโฆษณาทั้งหมดจะต้องถูกคิดคำนวณภาษีมูลค่าเพิ่ม
            ในกรณีที่ท่านซื้อการบริการโฆษณาโดยการซื้อเครดิตโฆษณาประเภทแพ็คเกจเครดิต
            (Ads Credit Packages)
            จำนวนเครดิตโฆษณาทั้งหมดที่ซื้อจะมีอายุการใช้งานภายในระยะเวลาที่กำหนดสำหรับแต่ละแพ็คเกจเครดิตและตามที่ได้แสดงไว้ในหน้าชำระเงิน
            (Checkout page) และในกรณีที่ท่านซื้อบริการโฆษณาโดยการใช้ส่วนลดจาก
            Ads Credit Voucher จำนวนเครดิตโฆษณาในส่วนที่ซื้อจากการใช้ส่วนลด Ads
            Credit Voucher
            จะมีอายุการใช้งานภายในระยะเวลาที่กำหนดตามที่ได้แสดงไว้ในหน้าชำระเงิน
            (Checkout page)
          </p>
          <p className="terms-content__paragraph">
            16.6 ท่านสามารถซื้อ Campaign Package
            ได้บนหน้าเว็บแพลตฟอร์มเครื่องมือทางการตลาด (Marketing Tools Site)
            เมื่อมีการเสนอขาย Campaign Package เป็นครั้งคราว ตามที่ Urbaan
            เป็นผู้กำหนดแต่เพียงผู้เดียว
            โดยท่านสามารถเลือกช่องทางการชำระเงินที่จัดให้มีโดย Urbaan
            บนหน้าเว็บแพลตฟอร์มเครื่องมือทางการตลาด (Marketing Tools Site)
          </p>
          <p className="terms-content__paragraph">
            16.7
            เว้นแต่จะได้กำหนดไว้เป็นอย่างอื่นในกฎเกณฑ์การให้บริการที่บังคับใช้
            ท่านไม่สามารถยกเลิกคำสั่งซื้อและ/หรือร้องขอคืนเงินค่าบริการโฆษณา
            หรือค่าบริการ Campaign Package
            ภายหลังจากที่ท่านได้ทำการชำระเงินเรียบร้อยแล้ว Urbaan
            จะออกใบแจ้งหนี้ในรูปแบบอิเล็กทรอนิกส์สำหรับค่าบริการโฆษณา และ/หรือ
            ค่าบริการ Campaign Package ที่ซื้อเป็นรายเดือน
            โดยใบแจ้งหนี้จะระบุชื่อและที่อยู่ที่ท่านได้แจ้งไว้ จำนวนเครดิตโฆษณา
            และ/หรือ Campaign Package ที่ซื้อ และยอดจำนวนเครดิตโฆษณาคงเหลือ ณ
            วันที่ออกใบแจ้งหนี้ (ถ้ามี) ทั้งนี้ Urbaan
            อาจให้เครดิตโฆษณาเพื่อเป็นการส่งเสริมการขายโดยไม่มีค่าใช้จ่ายแก่ท่าน
            เครดิตโฆษณาที่ไม่มีค่าใช้จ่ายดังกล่าวจะมีอายุการใช้งานเป็นไปตามรายละเอียดที่กำหนดในแต่ละโปรแกรม
            หากโปรแกรมใดไม่ได้กำหนดอายุการใช้งานของเครดิตโฆษณาไว้
            เครดิตโฆษณาดังกล่าวจะมีอายุการใช้งานเป็นระยะเวลา 1 เดือน
            นับจากวันที่ท่านได้รับเครดิตโฆษณาที่ไม่มีค่าใช้จ่ายนั้น
          </p>
          <p className="terms-content__paragraph">
            16.8 ท่านสามารถเลือกที่จะเติมเงินเครดิตโฆษณา (Advertising Credits)
            แบบอัตโนมัติ โดยการหักเงินจากยอดเงินรับคงเหลือ (Balance)
            ที่แสดงอยู่ในจาก Urbaan Seller Balance ของท่าน
            หรือวิธีการชำระเงินอื่นใดที่จัดให้มีโดย Urbaan
            (“การเติมเงินเครดิตโฆษณาแบบอัตโนมัติ”) หากจำนวนเงินเครดิตโฆษณา
            (Advertising Credits)
            ของท่านมีจำนวนคงเหลือต่ำกว่าจำนวนที่ท่านกำหนดไว้
            (“จำนวนเครดิตโฆษณาขั้นต่ำ”) ทั้งนี้ ณ
            ตอนที่ท่านสมัครใช้บริการเติมเงินเครดิตโฆษณาแบบอัตโนมัติ (Advertising
            Credits Top Up Feature) ท่านอาจเลือกจำนวนเครดิตโฆษณาขั้นต่ำ
            (Advertising Credits Minimum Amount) และจำนวนสำหรับการเติมเงิน
            โดยท่านตกลงยินยอมให้ Urbaan หักเงินจากจากยอดเงินรับคงเหลือ (Balance)
            ที่แสดงอยู่ใน Urbaan Seller Balance
            ของท่านตามเงื่อนไขที่กำหนดไว้ในข้อ 10. ของเงื่อนไขการให้บริการนี้
          </p>
          <p className="terms-content__paragraph">
            16.9 ท่านสามารถเลือกที่จะซื้อบริการโฆษณา Search Ads, Discovery Ads
            and Boost Ads
            ในเวลาที่ท่านได้ลงรายการสินค้าเพื่อจำหน่ายหรือภายหลังจากนั้น
            เมื่อท่านได้ซื้อการบริการโฆษณา Search Ads แล้ว ท่านสามารถกำหนดงบ
            คำสำคัญ ระยะเวลาการทำตลาด (marketing period) ฯลฯ
            สำหรับสินค้าแต่ละชนิดภายใต้กฎการให้บริการ ทั้งนี้ การให้บริการโฆษณา
            Search Ads จะเริ่มต้นและสิ้นสุดลงภายในระยะเวลาที่ท่านเป็นผู้กำหนด
            (“ระยะเวลาบริการโฆษณา Paid Advertising”)
            และไม่สามารถขอคืนเครดิตโฆษณา (Advertising Credits) ได้
          </p>
          <p className="terms-content__paragraph">
            16.10 นอกเหนือจากหลักเกณฑ์ตามข้อ 6
            สินค้าที่ได้ลงรายการไว้บนแพลตฟอร์มจะต้องมีความเหมาะสม
            และอยู่ภายใต้กฎหมาย กฎเกณฑ์การให้บริการ ข้อกำหนดและเงื่อนไข ๆ
            ที่เกี่ยวข้อง ท่านเข้าใจและตกลงให้ Urbaan มีสิทธิในการดำเนินการใด ๆ
            ตามข้อ 7.1 รวมถึงการลบรายการสินค้าออก
            ได้ทันทีหากมีเนื้อหาไม่เหมาะสมและละเมิดข้อกำหนดดังกล่าว
            และค่าธรรมเนียมการบริการโฆษณา หรือค่าบริการ Campaign Package
            ที่ท่านได้ชำระแล้ว
            หรือเครดิตโฆษณาที่ท่านได้ใช้กับสินค้าที่ได้ถูกลบออกภายใต้การให้บริการนี้
            ไม่สามารถขอคืนได้ไม่ว่าในกรณีใด
          </p>
          <p className="terms-content__paragraph">
            16.11 ท่านเข้าใจและยอมรับว่า Urbaan
            ไม่รับรองหรือรับประกันว่าจำนวนผู้เข้าชมหรือยอดขายของสินค้าของท่านจะเพิ่มขึ้นแต่อย่างใดจากการให้บริการโฆษณา
            หรือบริการ Campaign Package ดังกล่าว
          </p>
          <p className="terms-content__paragraph">
            16.12 ท่านควรซื้อการบริการโฆษณา และ/หรือ Campaign Package
            ภายหลังจากที่ท่านได้พิจารณางบประมาณและวัตถุประสงค์ในการโฆษณาของท่านแล้วเท่านั้น
            เว้นแต่ได้ระบุไว้ในข้อกำหนดการให้บริการนี้หรือกฎเกณฑ์การให้บริการ
            Urbaan จะไม่รับผิดต่อค่าชดเชยหรือความรับผิดใดๆ
            รวมถึงแต่ไม่จำกัดซึ่งค่าใช้จ่ายและผลกำไรที่สูญเสียไปตามจริง
            สำหรับผลลัพธ์หรือผลที่ตั้งใจไว้กับบริการโฆษณา หรือ Campaign Package
          </p>
          <p className="terms-content__paragraph">
            16.13 ไม่ว่าข้อกำหนดการให้บริการนี้จะระบุไว้ว่าอย่างไร หาก Urbaan
            ถูกศาลที่มีอำนาจพิพากษาให้รับผิด
            (รวมถึงการประมาทเลินเล่ออย่างร้ายแรง) เกี่ยวกับการให้บริการโฆษณา
            และ/หรือ Campaign Package ใด ๆ แล้วนั้น ในการนี้
            เท่าที่กฎหมายอนุญาตไว้ ความรับผิดของ Urbaan
            ต่อท่านหรือบุคคลภายนอกจะถูกจำกัดไว้เท่าจำนวนค่าบริการโฆษณา และ/หรือ
            Campaign Package ที่ท่านได้จ่ายไว้เท่านั้น
          </p>
          <p className="terms-content__heading">
            17. ค่าธรรมเนียมการใช้งานแพลตฟอร์ม
          </p>
          <p className="terms-content__paragraph">
            17.1 Urbaan
            เรียกเก็บค่าธรรมเนียมการให้บริการจากผู้ขายตามประเภทค่าธรรมเนียมการให้บริการ
            ซึ่งเป็นไปตามข้อกำหนดและเงื่อนไขที่กำหนดไว้โดย Urbaan
          </p>
          <p className="terms-content__sub-paragraph">
            17.1.1 ค่าธรรมเนียมการขายสินค้าและบริการ
          </p>
          <p className="terms-content__sub-paragraph">
            Urbaanเรียกเก็บค่าธรรมเนียมการทำธุรกรรมการขายจากผู้ขายเมื่อผู้ซื้อทำธุรกรรมการซื้อสินค้าและบริการใดๆ
            สำเร็จ โดยผู้ขายตกลงให้ Urbaan
            หักค่าธรรมเนียมดังกล่าวออกจากเงินค่าสินค้าและบริการของผู้ซื้อที่
            Urbaan จะโอนให้แก่ผู้ขาย (“ค่าธรรมเนียมการขาย”)
            โดยรายละเอียดเกี่ยวกับการเรียกเก็บค่าธรรมเนียมการขาย
            อัตราค่าธรรมเนียมการขาย
            วิธีการคิดคำนวณและเงื่อนไขที่เกี่ยวข้องจะเป็นไปตามเงื่อนไขที่กำหนดไว้โดย
            Urbaan ซึ่งอาจมีการเปลี่ยนแปลงแก้ไขเป็นครั้งคราวตามที่ Urbaan
            เห็นว่าเหมาะสมแก่สถานการณ์ตามสมควรและจะแจ้งให้ผู้ขาย/ผู้ใช้ทราบล่วงหน้าก่อนมีการเปลี่ยนแปลงแก้ไขในแต่ละคราวผ่านแพลตฟอร์ม
          </p>
          <p className="terms-content__sub-paragraph">
            17.1.2 ค่าธรรมเนียมการทำธุรกรรม ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ.
          </p>
          <p className="terms-content__sub-paragraph">
            (1) ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิต
            ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตแบบผ่อนชำระ
            และค่าธรรมเนียมการทำธุรกรรมในรูปแบบอื่น ๆ
            ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิต
            จะถูกจัดเก็บเมื่อผู้ซื้อได้ชำระค่าสินค้าผ่านบัตรเครดิตหรือบัตรเดบิต
            ไม่ว่าจะชำระเต็มจำนวนหรือชำระแบบผ่อนชำระ โดย Urbaan
            จะจัดเก็บค่าธรรมเนียมบัตรเครดิตโดยหักค่าธรรมเนียมดังกล่าวออกจากเงินค่าซื้อสินค้าของผู้ซื้อที่
            Urbaan จะโอนให้แก่ผู้ขาย (ต่อไปนี้จะเรียกว่า
            “ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิต” หรือ
            “ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตแบบผ่อนชำระ” แล้วแต่กรณี)
            โดยที่ผู้ขายจะเป็นฝ่ายรับผิดชอบค่าธรรมเนียมดังกล่าวนี้แต่เพียงผู้เดียว
          </p>
          <p className="terms-content__sub-paragraph">
            (2) ค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิต
            และค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตแบบผ่อนชำระ จะถูกกำหนดโดย
            Urbaan
            รายละเอียดเกี่ยวกับการเรียกเก็บค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิต
            อัตราค่าธรรมเนียม
            วิธีการคิดคำนวณและเงื่อนไขที่เกี่ยวข้องเป็นไปตามเงื่อนไขที่กำหนดไว้โดย
            Urbaan และอาจมีการเปลี่ยนแปลงแก้ไขเป็นครั้งคราวตามที่ Urbaan
            เห็นว่าเหมาะสมแก่สถานการณ์ตามสมควรและจะแจ้งให้ผู้ขาย/ผู้ใช้ทราบล่วงหน้าก่อนมีการเปลี่ยนแปลงแก้ไขในแต่ละคราวผ่านแพลตฟอร์ม
          </p>
          <p className="terms-content__sub-paragraph">
            (3)
            ผู้ขายอาจบวกค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตหรือบัตรเดบิตหรือค่าธรรมเนียมการทำธุรกรรมผ่านบัตรเครดิตแบบผ่อนชำระ
            ไปในราคาสินค้าที่จำหน่ายได้
            ในกรณีดังกล่าวผู้ขายตกลงที่จะไม่เรียกเก็บค่าธรรมเนียมอื่นใดที่เกี่ยวข้องกับการใช้บัตรเครดิตหรือบัตรเดบิตจากผู้ซื้ออีก
            Urbaan
            สงวนสิทธิในการหยุดชั่วคราวหรือยกเลิกการให้บริการบัญชีของผู้ขายในกรณีที่ผู้ขายได้ละเมิดเงื่อนไขดังกล่าวข้างต้น
          </p>
          <p className="terms-content__sub-paragraph">
            (4) ค่าธรรมเนียมการทำธุรกรรมประเภทอื่น ๆ ภายใต้การกำหนดโดย Urbaan
          </p>
          <p className="terms-content__paragraph">
            17.2 เมื่อมีการเรียกเก็บค่าธรรมเนียม ค่าธรรมเนียมดังกล่าวอาจมีการคิด
            VAT/GST และภาษีที่เกี่ยวข้องอื่น ๆ รวมเข้าไปด้วย ทั้งนี้
            ผู้ขายจะรับผิดชอบค่าภาษีเหล่านั้นเอง เว้นแต่ตกลงกันไว้เป็นอย่างอื่น
            โดยผู้ขายตกลงว่า Urbaan อาจหักค่าธรรมเนียมและภาษีต่าง ๆ
            ที่เกี่ยวข้องจากเงินค่าซื้อสินค้าและบริการที่ผู้ซื้อชำระไว้ โดย
            Urbaan จะออกใบเสร็จรับเงิน (Receipt) หรือใบกำกับภาษี (Invoice)
            สำหรับค่าธรรมเนียมและภาษีที่ผู้ขายชำระไว้เมื่อผู้ร้องขอ
          </p>
          <p className="terms-content__paragraph">
            17.3 หากค่าธรรมเนียมใดๆ (รวมภาษีมูลค่าเพิ่ม/VAT)
            มีตัวเลขทศนิยมเศษสตางค์เกินกว่าหรือเท่ากับ 50 สตางค์
            ผู้ขายตกลงให้เรียกเก็บค่าธรรมเนียมดังกล่าวในจำนวนหลังการปัดเศษขึ้นเป็นจำนวนเต็ม
            และตกลงให้เรียกเก็บค่าธรรมเนียมในจำนวนหลังปัดเศษลงเป็นจำนวนเต็ม
            หากค่าธรรมเนียม (รวมภาษีมูลค่าเพิ่ม/VAT)
            มีตัวเลขทศนิยมเศษสตางค์น้อยกว่า 50 สตางค์
            และผู้ขายตกลงชำระค่าธรรมเนียมตามจำนวนที่เรียกเก็บดังกล่าวนั้นแก่
            Urbaan
          </p>
          <p className="terms-content__paragraph">
            17.4 Urbaan
            สงวนสิทธิที่จะปรับเปลี่ยนค่าธรรมเนียมและอัตราค่าธรรมเนียมใด ๆ
            ที่จะถูกจัดเก็บโดย Urbaan
            และเมื่อภายหลังจากได้มีการปรับเปลี่ยนค่าธรรมเนียมแล้ว
            หากท่านยังคงใช้บริการนี้ต่อไป
            จะถือว่าท่านได้ยอมรับการปรับเปลี่ยนค่าธรรมเนียมดังกล่าวทันที
          </p>
          <p className="terms-content__heading">18. กรณีเกิดข้อพิพาท</p>
          <p className="terms-content__paragraph">
            18.1 ในกรณีที่เกิดปัญหาในการทำธุรกรรม
            ผู้ซื้อและผู้ขายตกลงที่จะปรึกษาหารือและเจรจากันอย่างฉันท์มิตร
            และหากไม่สามารถตกลงกันได้
            การยุติข้อพิพาทของปัญหานั้นจะเป็นไปตามนโยบายใด ๆ ของ Urbaan
          </p>
          <p className="terms-content__paragraph">
            18.2
            ผู้ซื้อและผู้ขายให้สัญญาว่าตนจะไม่ฟ้องร้องหรือยื่นข้อร้องเรียนใด ๆ
            ต่อ Urbaan หรือบริษัทในเครือทั้งหมด เว้นแต่เป็นกรณีที่ Urbaan
            หรือบริษัทในเครือเป็นผู้จำหน่ายสินค้าหรือให้บริการในธุรกรรมตามข้อเรียกร้องดังกล่าวที่เกี่ยวข้องกับธุรกรรมใด
            ๆ ที่ทำขึ้นบนแพลตฟอร์มหรือข้อพิพาทใด ๆ
            ที่เกี่ยวข้องกับธุรกรรมดังกล่าว
          </p>
          <p className="terms-content__paragraph">
            18.3 ผู้ใช้ที่ได้รับการคุ้มครองภายใต้ การอำนวยความสะดวกของ Urbaan
            สามารถส่งคำขอเป็นลายลักษณ์อักษรไปยัง Urbaan
            เพื่อให้ช่วยในการยุติปัญหาซึ่งอาจเกิดขึ้นจากการทำธุรกรรมเมื่อได้รับการร้องขอ
            Urbaan อาจกระทำตามดุลยพินิจแต่เพียงผู้เดียวของของ Urbaan
            และโดยไม่มีความรับผิดอย่างสิ้นเชิงต่อผู้ซื้อและผู้ขาย
            ดำเนินขั้นตอนทั้งหมดที่จำเป็นเพื่อช่วยผู้ใช้ยุติข้อพิพาทระหว่างกัน
          </p>
          <p className="terms-content__paragraph">
            18.4 ท่านตกลงที่จะปกป้อง ชดใช้ และทำให้ Urbaan ผู้ถือหุ้น บริษัทย่อย
            บริษัทในเครือ กรรมการ เจ้าหน้าที่ ตัวแทน พนักงาน
            และผู้ร่วมยี่ห้อพ้นจากการดำเนินการใด การเรียกร้องสิทธิ การดำเนินคดี
            และการฟ้องร้องคดี รวมถึงหนี้สิน ความเสียหาย การชำระหนี้ บทลงโทษ
            ค่าปรับ ค่าใช้จ่ายและต้นทุนใด ๆ ที่เกี่ยวข้องทั้งหมด
            รวมถึงแต่ไม่จำกัดเพียง ค่าใช้จ่ายในการยุติข้อพิพาทอื่น ๆ
            ที่เกิดแก่บุคคลดังกล่าวข้างต้น อันเกิดจากหรือเกี่ยวกับ: (1)
            ธุรกรรมใด ๆ ที่ทำขึ้นบนแพลตฟอร์ม หรือข้อพิพาทใด ๆ
            ที่เกี่ยวข้องกับธุรกรรมดังกล่าว เว้นแต่กรณีที่ Urbaan
            หรือบริษัทในเครือเป็นผู้จำหน่ายสินค้าในธุรกรรมที่เกี่ยวข้องกับข้อพิพาทดังกล่าว)
            (2) การอำนวยความสะดวกของ Urbaan (3) การดำเนินงาน
            การจัดการและ/หรือการดูแลระบบบริการ โดยหรือในนามของ Urbaan (4)
            การฝ่าฝืนหรือละเมิดเงื่อนไขใดๆ
            ในเงื่อนไขการให้บริการนี้หรือแนวทางปฏิบัติอื่นใดที่อ้างถึงในที่นี่
            (5) การใช้หรือใช้บริการในทางที่ผิด หรือ (6)
            การละเมิดกฎหมายหรือสิทธิใด ๆ ของบุคคลภายนอก
          </p>
          <p className="terms-content__heading">19. การรับฟังความคิดเห็น</p>
          <p className="terms-content__paragraph">
            19.1 Urbaan รับฟังทุกความคิดเห็นจากผู้ใช้ โดย
          </p>
          <p className="terms-content__sub-paragraph">
            19.1.1 สามารถส่งความคิดเห็นเป็นใช้แบบฟอร์มความคิดเห็นในช่องทางที่
            Urbaan ได้จัดไว้ให้แสดงความคิดเห็น หรือส่งทางอีเมลให้แก่
            admin@urbaancomunities.com
          </p>
          <p className="terms-content__sub-paragraph">
            19.1.2
            ไม่รับความคิดเห็นที่เป็นเรื่องเท็จและทำให้ฝ่ายที่ถูกกระทบสิทธินั้นเสื่อมเสีย
          </p>
          <p className="terms-content__sub-paragraph">
            19.1.3
            ผู้ใช้ที่ได้รับผลกระทบจากความคิดเห็นจะได้รับโอกาสให้ทำเรื่องชี้แจงเป็นลายลักษณ์อักษรต่อ
            Urbaan
          </p>
          <p className="terms-content__heading">20. การปฏิเสธความรับผิด</p>
          <p className="terms-content__paragraph">
            20.1 บริการนี้จัดไว้ให้ตามสภาพแห่งความเป็นจริงโดยไม่มีการรับรอง
            หรือการรับประกันโดย Urbaan ไม่ว่าในลักษณะใด
            ทั้งแบบชัดแจ้งหรือโดยปริยายเกี่ยวกับการค้า รวมถึงแต่ไม่จำกัดเพียง
            การรับประกันคุณภาพการปฏิบัติงาน ความสามารถในการทำการค้า
            การไม่ละเมิดสิทธิหรือความเหมาะสมสำหรับวัตถุประสงค์ในการใช้งาน
            ทั้งจะไม่มีการรับประกันที่เกิดขึ้นระหว่างการติดต่อ การดำเนินงาน
            หรือการใช้เพื่อการค้า โดยไม่เป็นการจำกัดสิ่งที่กล่าวไปก่อนหน้านี้
            Urbaan ไม่รับประกันว่าบริการแพลตฟอร์มนี้
            หรือการทำงานในแพลตฟอร์มจะพร้อมใช้งานได้ เข้าถึงได้ ไม่หยุดชะงัก
            ทันต่อเวลา ปลอดภัย ถูกต้อง ครบถ้วน
            หรือปราศจากข้อผิดพลาดว่าข้อบกพร่อง หากมี
            จะได้รับการแก้ไขหรือว่าแพลตฟอร์มนี้ และ/หรือ เซิร์ฟเวอร์ (ระบบ)
            ของแพลตฟอร์มจะใช้งานได้โดยปราศจากไวรัส นาฬิกา ระบบตั้งเวลา ตัวนับ
            หนอน ล็อคซอฟต์แวร์ อุปกรณ์สอดแนม ม้าโทรจัน ประตูกับดัก ระเบิดเวลา
            หรือรหัส คำสั่ง โปรแกรม หรือส่วนประกอบหรือสิ่งที่เป็นอันตรายอื่นใด
          </p>
          <p className="terms-content__paragraph">
            20.2
            ท่านรับทราบว่าความเสี่ยงทั้งหมดที่เกิดขึ้นจากการใช้งานแพลตฟอร์มหรือการดำเนินงานของแพลตฟอร์มนี้
            และ/หรือบริการนั้นตกเป็นของท่านแต่เพียงผู้เดียว
          </p>
          <p className="terms-content__paragraph">
            20.3 Urbaan ไม่ได้เป็นผู้ควบคุมและไม่รับประกันหรือรับผิดชอบต่อ: (1)
            การมีอยู่ ความชอบด้วยกฎหมายของสินค้าที่วางจำหน่ายผ่านบนแพลตฟอร์ม
            คุณภาพ หรือความปลอดภัย หรือ (2)
            ความสามารถของผู้ขายในการขายสินค้าและบริการหรือของผู้ซื้อในการชำระค่าสินค้า
          </p>
          <p className="terms-content__heading">
            21. ข้อยกเว้นและข้อจำกัดการรับผิด
          </p>
          <p className="terms-content__paragraph">
            21.1 ไม่ว่าจะเป็นกรณีใดก็ตาม Urbaan จะไม่รับผิดไม่ว่าตามสัญญา
            การรับประกัน ความรับผิดของผลิตภัณฑ์ การละเมิด
            รวมถึงแต่ไม่จำกัดเพียงความประมาทเลินเล่อ
            หรือประเด็นฟ้องอื่นตามกฎหมาย หรือความรับผิดอื่นใด ต่อ:
          </p>
          <p className="terms-content__sub-paragraph">
            21.1.1 (1) การสูญเสียจากการใช้งาน (2) การสูญเสียรายได้ (3)
            การสูญเสียกำไร (4) การสูญเสียค่าความนิยม (5)
            การล้มเหลวในเงินที่คาดการณ์ไว้ หรือ (6) การสูญเสียข้อมูล หรือ
          </p>
          <p className="terms-content__sub-paragraph">
            21.1.2
            ความเสียหายทางอ้อมที่เกิดจากหรือเกี่ยวเนื่องกับการใช้หรือการไม่สามารถใช้แพลตฟอร์มนี้หรือบริการ
            รวมถึงแต่ไม่จำกัดเพียงความเสียหายอันเกิดจากสิ่งดังกล่าว แม้ว่า
            Urbaan จะได้รับแจ้งความเสียหายดังกล่าวแล้วก็ตาม
          </p>
          <p className="terms-content__paragraph">
            21.2
            ท่านรับทราบและตกลงว่าสิทธิเพียงอย่างเดียวที่ท่านมีเกี่ยวกับปัญหาหรือความไม่พึงพอใจใด
            ๆ ในบริการคือการขอให้ยกเลิกบัญชีของท่าน และ/หรือหยุดการใช้งานบริการ
          </p>
          <p className="terms-content__paragraph">
            21.3 ในกรณีที่ Urbaan ได้รับคำสั่งจากศาลให้ต้องรับผิด
            รวมถึงต่อการประมาทเลินเล่ออย่างร้ายแรง
            ความรับผิดต่อท่านหรือบุคคลภายนอก จะจำกัดอยู่เพียง 2,000 บาท
            (สองพันบาท)
          </p>
          <p className="terms-content__paragraph">
            21.4 หาก Urbaan ได้กระทำความผิดจริง Urbaan
            จะมีความรับผิดต่อการเสียชีวิต
            หรือการบาดเจ็บร่างกายอันเกิดจากความประมาทเลินเล่อของ Urbaan
            การฉ้อโกง หรือต่อความรับผิดอื่นใดในส่วนของ Urbaan ที่ไม่สามารถจำกัด
            และ/หรือ ยกเว้นได้ตามกฎหมาย
          </p>
          <p className="terms-content__heading">
            22. ลิงค์ไปยังเว็บของบุคคลภายนอก
          </p>
          <p className="terms-content__paragraph">
            22.1 ลิงค์ของบุคคลภายนอกซึ่งมีอยู่ทั่วทั้งแพลตฟอร์ม
            จะให้ท่านสามารถออกจากแพลตฟอร์มนี้ได้ ลิงก์เหล่านี้จัดไว้ให้ตามมารยาท
            และแพลตฟอร์มที่มีลิงก์ไปไม่ได้อยู่ภายใต้การควบคุมของ Urbaan
            ไม่ว่าในลักษณะใด
            และท่านเข้าถึงแพลตฟอร์มดังกล่าวด้วยความเสี่ยงของท่านเอง Urbaan
            ไม่รับผิดชอบไม่ว่ากรณีใดต่อเนื้อหาของแพลตฟอร์มที่ลิงก์ไปดังกล่าว
            หรือลิงก์ที่อยู่ในแพลตฟอร์มที่มีลิงก์ไป
            รวมถึงการเปลี่ยนแปลงหรือการอัปเดตแพลตฟอร์มดังกล่าว Urbaan
            จัดลิงก์เหล่านี้ไว้ให้เพื่อความสะดวกเท่านั้น และการรวมลิงก์ใด ๆ
            ไว้ไม่ได้แสดงนัยหรือการเชื่อมโยงอย่างชัดแจ้ง การรับรอง
            หรือการเป็นผู้สนับสนุนโดย Urbaan ถึงแพลตฟอร์มที่ลิงก์ไปใด ๆ
            และ/หรือเนื้อหาในแพลตฟอร์มที่ลิงก์ไปนั้น
          </p>
          <p className="terms-content__heading">23. การมีส่วนร่วมของท่าน</p>
          <p className="terms-content__paragraph">
            23.1 การส่งเนื้อหาเพื่อรวมไว้ในบริการ
            แสดงว่าท่านยืนยันและรับประกันว่าท่านมีสิทธิ และ/หรือ
            การอนุญาตที่จำเป็นทั้งหมดเพื่อมอบสิทธิ์การใช้งานด้านล่างแก่ Urbaan
            ท่านยังรับทราบและตกลงต่อไปว่าท่านเป็นผู้รับผิดชอบแต่เพียงผู้เดียวในสิ่งใดก็ตามที่ท่านแสดงหรือใช้งานได้บนหรือผ่านทางบริการ
            รวมถึงแต่ไม่จำกัดเพียงความถูกต้อง การปลอดจากสิทธิ์ ความน่าเชื่อถือ
            ลักษณะ และข้อจำกัดทางกฎหมายที่เกี่ยวข้องกับเนื้อหาที่ท่านส่งเข้ามา
            ท่านมอบสิทธิ์การใช้งานที่เพิกถอนไม่ได้ เป็นสากล เป็นทางการ ไม่ผูกขาด
            ปลอดค่าลิขสิทธิ์ สามารถมอบสิทธิต่อไปได้ และเปลี่ยนมือได้ ให้แก่
            Urbaan และผู้รับช่วงต่อในการแสดงต่อสาธารณะ การคัดลอก แก้ไข แจกจ่าย
            เผยแพร่ซ้ำ ส่งต่อ ดัดแปลง ปรับเปลี่ยน และปฏิบัติการต่อสาธารณะ
            เนื้อหาที่ส่งเข้ามาดังกล่าวนั้นที่เกี่ยวกับบริการ ในรูปแบบใด ๆ
            และผ่านช่องทางอื่นใด รวมถึงแต่ไม่จำกัดเพียง
            เพื่อการส่งเสริมการขายและแจกจ่ายส่วนต่าง ๆ ของบริการ
            โดยไม่ต้องมีอำนาจที่ได้รับมอบหมาย (มอบอำนาจ)
            และท่านตกลงที่จะสละสิทธิทางศีลธรรมใด ๆ และสิทธิที่คล้ายกันในส่วนต่าง
            ๆ ในเรื่องดังกล่าว
            ท่านทราบดีว่าสิ่งที่ท่านส่งเข้ามานั้นอาจถูกส่งต่อทางช่องทางต่าง ๆ
            และถูกเปลี่ยนเพื่อให้ตรงตามและปรับให้เข้ากับทางเทคนิค
          </p>
          <p className="terms-content__paragraph">
            23.2 ข้อมูล วัสดุ หรือแนวคิดใด ๆ ที่ท่านแสดงบนหรือผ่านทางแพลตฟอร์ม
            หรือส่งต่อมายัง Urbaan ไม่ว่าด้วยวิธีใด (เรียกว่า “สิ่งที่ส่งมา”)
            ไม่ถือว่าเป็นความลับโดย Urbaan และอาจถูกเผยแพร่หรือใช้โดย Urbaan
            โดยไม่จำต้องขออนุญาตและปราศจากการชดเชยหรือการรับผิดต่อท่าน
            ไม่ว่าด้วยจุดประสงค์ใดก็ตาม รวมถึงแต่ไม่จำกัดเพียง
            การทำตลาดผลิตภัณฑ์ การพัฒนา และการผลิตในการส่งสิ่งที่ส่งมาแก่ Urbaan
            ท่านยืนยันและตกลงว่า Urbaan และ/หรือ บุคคลภายนอก อาจพัฒนาแอปพลิเคชัน
            ซอฟต์แวร์ อินเทอร์เฟส ผลิตภัณฑ์
            และส่วนปรับปรุงของสิ่งดังกล่าวโดยอิสระ ซึ่งมีลักษณะการทำงาน
            หรือลักษณะพิเศษอื่นอย่างใด ๆ
            ตรงหรือคล้ายกับแนวคิดที่แสดงเป็นสิ่งที่ส่งมาของท่าน
            ด้วยประการฉะนี้ท่านจึงได้มอบสิทธิ์การใช้งานที่เพิกถอนไม่ได้ เป็นสากล
            เป็นทางการ ไม่ผูกขาด ปลอดค่าลิขสิทธิ์ สามารถมอบสิทธิต่อไปได้
            และเปลี่ยนมือให้แก่กันได้ ให้แก่ Urbaan และผู้รับช่วงต่อ
            ในการพัฒนาสิ่งที่กล่าวมาข้างตน และเพื่อใช้ คัดลอก แจกจ่าย เผยแพร่ซ้ำ
            ส่งต่อ ดัดแปลง ปรับเปลี่ยน และแสดงต่อสาธารณะ สิ่งที่ส่งมาดังกล่าวบน
            ผ่านทางหรือที่เกี่ยวกับบริการ ในรูปแบบใด ๆ และผ่านช่องทางใด
            รวมถึงแต่ไม่จำกัดเพียง
            เพื่อการส่งเสริมการขายและของบริการโดยไม่ต้องมีอำนาจหน้าที่ที่ได้รับมอบหมาย
            และท่านตกลงที่จะสละสิทธิทางศีลธรรมใด ๆ
            ข้อกำหนดนี้ไม่ใช้บังคับกับข้อมูลส่วนบุคคลที่อยู่ภายใต้การบังคับของพระราชบัญญัติข้อมูลส่วนบุคคล
            พ.ศ.2562 หรือข้อมูลส่วนบุคคลที่กำหนดโดย Urbaan
            เว้นแต่ท่านทำให้ข้อมูลส่วนบุคคลดังกล่าวใช้งานได้บนสาธารณะหรือบนแพลตฟอร์ม
          </p>
          <p className="terms-content__heading">
            24. การมีส่วนร่วมของบุคคลภายนอกต่อบริการ
          </p>
          <p className="terms-content__paragraph">
            24.1 ผู้มีส่วนร่วมในบริการแต่ละคนทางข้อมูล ข้อความ ภาพ เสียง วิดีโอ
            ซอฟต์แวร์ และเนื้อหาอื่นใด
            จะเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อข้อเท็จจริง ความถูกต้อง
            ความแม่นยำ การปฏิบัติตามกฎหมาย
            และข้อจำกัดทางกฎหมายที่เกี่ยวกับเนื้อหาที่ส่งเข้ามา ดังนั้น Urbaan
            จึงไม่จำต้องรับผิดชอบต่อ
            และจะไม่เฝ้าติดตามหรือตรวจสอบอย่างสม่ำเสมอถึงความถูกต้อง ความแม่นยำ
            การปฏิบัติตามกฎหมายและข้อจำกัดทางกฎหมายที่เกี่ยวข้องกับเนื้อหาที่ส่งเข้ามา
            ท่านจะไม่กำหนดให้ Urbaan
            ต้องรับผิดชอบต่อการดำเนินการหรือไม่ดำเนินการของผู้ใช้
            รวมถึงแต่ไม่จำกัดเพียง สิ่งที่แสดงหรือทำให้ใช้งานได้ผ่านทางบริการ
          </p>
          <p className="terms-content__paragraph">
            24.2 นอกจากนี้บริการอาจมีลิงก์ไปยังเว็บแพลตฟอร์ม ผลิตภัณฑ์ สินค้า
            บริการและการเสนอของบุคคลภายนอก เว็บแพลตฟอร์ม ลิงก์ผลิตภัณฑ์
            บริการของบุคคลภายนอกเหล่านี้ไม่ได้เป็นของหรือควบคุมโดย Urbaan
            แต่ดำเนินการโดย และเป็นทรัพย์สินของบุคคลภายนอก
            และอาจได้รับการคุ้มครองตามกฎหมายลิขสิทธิ์หรือกฎหมายและสนธิสัญญาว่าด้วยทรัพย์สินทางปัญญาอื่น
            ๆ ที่บังคับใช้ Urbaan ไม่มีหน้าที่ตรวจสอบ
            และไม่จำต้องรับผิดชอบต่อเนื้อหา บริการ ฟังก์ชั่นการทำงาน ความปลอดภัย
            หรือการปฏิบัติอย่างใด ๆ ของบุคคลภายนอกเหล่านี้ ท่านตกลงว่า Urbaan
            จะไม่รับผิดชอบในลักษณะใดก็ตามอันเนื่องมาจากการใช้งานของท่านหรือการไม่สามารถใช้งานเว็บแพลตฟอร์มหรือการใช้งานอื่นใด
            ท่านยืนยันและตกลงว่า Urbaan อาจยกเลิกการใช้งานของท่าน
            หรือลบลิงก์ของบุคคลภายนอก หรือแอปพลิเคชันบนบริการ
            ตามขอบเขตที่การใช้งานนั้นละเมิดเงื่อนไขการให้บริการนี้
          </p>
          <p className="terms-content__heading">
            25. การรับรองและการรับประกันของผู้ใช้บริการแพลตฟอร์ม
          </p>
          <p className="terms-content__paragraph">ท่านยืนยันและรับประกันว่า:</p>
          <p className="terms-content__paragraph">
            (1) ท่านบรรลุนิติภาวะตามประมวลกฎหมายแพ่งและพาณิชย์
            หรือในกรณีที่ท่านเป็นผู้เยาว์ท่านได้รับความยินยอมจากพ่อแม่หรือผู้ปกครองตามกฎหมายให้มีสิทธิและความสามารถที่จะเข้าทำสัญญาเงื่อนไขการให้บริการนี้และปฏิบัติตามเงื่อนไขนี้แล้ว
            และ
          </p>
          <p className="terms-content__paragraph">
            (2)
            ท่านจะใช้บริการแพลตฟอร์มโดยมีวัตถุประสงค์ที่ถูกกฎหมายและตามเงื่อนไขการให้บริการนี้เท่านั้น
            หาก Urbaan
            ตรวจสอบแล้วเห็นว่าท่านกระทำการใดโดยมีวัตถุประสงค์ในการกระทำผิดกฎหมายหรือจารีตประเพณี
            Urbaan มีอำนาจที่จะลบหรือหยุดการให้บริการบัญชีของท่านได้ทันที
          </p>
          <p className="terms-content__heading">
            26. การกระทำอันเป็นการฉ้อโกงหรือการกระทำที่ต้องสงสัย
          </p>
          <p className="terms-content__paragraph">
            ในกรณีที่ Urbaan
            มีเหตุอันควรเชื่อได้ว่าท่านได้ทำธุรกรรมหรือกระทำการใด ๆ
            ที่อาจเป็นการฉ้อโกง ฉ้อโกงประชาชนหรือเป็นที่ต้องสงสัย Urbaan
            อาจใช้ดุลยพินิจแต่เพียงผู้เดียวในการใช้มาตรการต่าง ๆ เพื่อปกป้อง
            Urbaan ผู้ซื้อหรือผู้ขายคนอื่นๆ
            หรือบุคคลภายนอกจากการการคัดค้านการจ่ายเงิน คืนเงิน
            การปฏิเสธการจ่ายเงิน ค่าธรรมเนียม ค่าปรับ
            เบี้ยปรับและความรับผิดอื่นใด มาตรการได้แก่
          </p>
          <p className="terms-content__sub-paragraph">
            (1) Urbaan อาจระงับสิทธิของท่านสำหรับการได้รับการอำนวยความสะดวกจาก
            Urbaan
          </p>
          <p className="terms-content__sub-paragraph">
            (2) Urbaan อาจจะจำกัด ระงับ
            ปิดหรือการเข้าถึงบัญชีของท่านหรือการให้บริการ และ/หรือ
            ระงับการทำธุรกรรมทั้งหมด
          </p>
          <p className="terms-content__sub-paragraph">
            (3) Urbaan
            อาจถือครองเงินของท่านในระยะเวลาที่จำเป็นต่อการป้องกันความเสี่ยงที่อาจก่อให้เกิดความรับผิดต่อ
            Urbaan หรือบุคคลภายนอก หรือกรณีที่ Urbaan
            มีความเชื่อมั่นว่าท่านได้กระทำการหรือทำธุรกรรมใด ๆ
            ที่อาจเป็นการฉ้อโกงหรือเป็นที่ต้องสงสัย
          </p>
          <p className="terms-content__sub-paragraph">
            (4) Urbaan อาจยึดเหนี่ยว ถือครอง
            ใช้หรือโอนเงินที่อยู่ในบัญชีของท่านตามคำสั่งและคำพิพากษาที่เกี่ยวกับท่านหรือบัญชีของท่าน
            รวมถึงคำสั่งและคำพิพากษาของศาลแห่งราชอาณาจักรไทยหรือที่อื่นใดที่เกี่ยวกับ
            Urbaan
          </p>
          <p className="terms-content__sub-paragraph">
            (5) Urbaan อาจปฏิเสธการให้บริการแก่ท่านทันที
          </p>
          <p className="terms-content__heading">
            27. ข้อกำหนดที่แยกออกจากกันได้
          </p>
          <p className="terms-content__paragraph">
            หากบทบัญญัติใดในเงื่อนไขการให้บริการนี้ถือว่าผิดกฎหมาย เป็นโมฆะ
            หรือไม่สามารถบังคับใช้ได้ไม่ว่าด้วยเหตุผลใดภายใต้กฎหมายของเขตอำนาจศาลของประเทศนั้น
            ๆ ให้ถือว่าบทบัญญัตินั้นแยกออกจากกันได้จากข้อกำหนดและเงื่อนไขนี้
            และไม่ส่งผลต่อความสมบูรณ์และการมีผลบังคับใช้ของบทบัญญัติอื่น ๆ
            ที่เหลืออยู่
            หรือความสมบูรณ์และการมีผลบังคับใช้ของบทบัญญัติที่มีปัญหาภายใต้กฎหมายของเขตอำนาจศาลของประเทศไทย
          </p>
          <p className="terms-content__heading">
            28. กฎหมายที่ใช้บังคับและการตีความตามกฎหมาย
          </p>
          <p className="terms-content__paragraph">
            เงื่อนไขการให้บริการนี้อยู่ภายใต้บังคับและตีความตามกฎหมายของราชอาณาจักรไทย
            โดยไม่คำนึงถึงหลักกฏหมายขัดกัน ทั้งนี้
            เว้นแต่กฎหมายที่บังคับใช้จะกำหนดไว้เป็นอย่างอื่น ข้อขัดแย้ง ข้อพิพาท
            การเรียกร้องสิทธิหรือความแตกต่างทุกประเภทที่อาจเกิดขึ้นจากหรือเกี่ยวข้องกับเงื่อนไขการให้บริการนี้ต่อหรือที่เกี่ยวกับ
            Urbaan ให้มีการวินิจฉัยชี้ขาดเป็นที่สุดโดยอนุญาโตตุลาการในประเทศไทย
            ตามข้อบังคับสถาบันอนุญาโตตุลาการว่าด้วยอนุญาโตตุลาการ
            ใช้บังคับอยู่ในขณะที่มีการเสนอข้อพิพาทเพื่อให้อนุญาโตตุลาการ
            จัดการตามของสถาบันอนุญาโตตุลาการ โดยจัดให้มีอนุญาโตตุลาการหนึ่ง (1)
            ท่านและให้ใช้ภาษาในการอนุญาโตตุลาการเป็นภาษาไทยเท่านั้น
          </p>
          <p className="terms-content__heading">29. บทบัญญัติอื่น</p>
          <p className="terms-content__paragraph">
            29.1 ท่านต้องไม่มอบหมาย ให้สิทธิ์การใช้งานต่อ
            หรือโอนสิทธิที่มอบให้แก่บุคคลอื่นที่มิใช่ตัวท่านหรือทำสัญญาช่วงข้อผูกพันใดๆ
            ของท่าน โดยไม่ได้รับความยินยอมจาก Urbaan หากท่านฝ่าฝืน Urbaan
            ขอสงวนสิทธิ์ในการลงโทษในกรณีที่ท่านฝ่าฝืนต่อไป
          </p>
          <p className="terms-content__paragraph">
            29.2 Urbaan อาจจะดำเนินการใด ๆ
            ซึ่งอาจเป็นการรบกวนการทำของงานแพลตฟอร์มหรือส่วนหนึ่งส่วนใดของแพลตฟอร์ม
            ตามที่จำเป็นเพื่อการบำรุงรักษาแบบประจำหรือเป็นครั้งคราวเพื่อแก้ไขข้อบกพร่อง
            หรือการปรับปรุงเปลี่ยนแปลงใด ๆ และUrbaanไม่จำต้องรับผิดชอบใด ๆ
            ต่อท่านจากการระงับหรือยกเลิกดังกล่าว ทั้งนี้ Urbaan
            จะใช้ความพยายามอย่างสูงสุดเพื่อแจ้งให้ท่านทราบว่าหากแพลตฟอร์มหรือส่วนหนึ่งส่วนใดของแพลตฟอร์มถูกระงับหรือยกเลิกการใช้งาน
          </p>
          <p className="terms-content__paragraph">
            29.3 Urbaan
            อาจแก้ไขเงื่อนไขการให้บริการนี้ได้ตลอดเวลาโดยแสดงเงื่อนไขการให้บริการฉบับแก้ไขบนแพลตฟอร์มนี้
            และแจ้งให้ท่านทราบล่วงหน้าในระยะเวลาอันสมควร
            การใช้งานแพลตฟอร์มนี้ของท่าน
            หลังการเปลี่ยนแปลงดังกล่าวจะถือว่าท่านยอมรับเงื่อนไขการให้บริการฉบับแก้ไขนั้นแล้ว
          </p>
          <p className="terms-content__paragraph">
            29.4 ระหว่างท่านและ Urbaan
            ไม่มีสิ่งใดในเงื่อนไขการให้บริการนี้ถือว่าเป็นการเป็นหุ้นส่วน
            การลงทุนร่วม ลูกจ้าง นายจ้าง หรือความสัมพันธ์ระหว่างตัวการกับตัวแทน
            และไม่อนุญาตให้ท่านสร้างภาระค่าใช้จ่ายหรือหนี้สินในนามของ Urbaan
            หากท่านฝ่าฝืน
            ท่านต้องรับผิดชอบค่าใช้จ่ายดังกล่าวด้วยตัวเองและหากเกิดความเสียหายต่อ
            Urbaan ท่านจำต้องชดใช้ค่าความเสียหายแก่ Urbaan ด้วย
          </p>
          <p className="terms-content__paragraph">
            29.5 การไม่ใช้สิทธิของ Urbaan
            ระหว่างอายุแห่งข้อตกลงฉบับนี้หรือข้อตกลงฉบับอื่น
            ที่จะบังคับใช้ข้อกำหนดหรือเงื่อนไขนี้
            ไม่ส่งผลกระทบต่อสิทธิของตนในภายหลังที่จะบังคับใช้ข้อกำหนดหรือเงื่อนไขดังกล่าว
            เว้นแต่ Urbaan ได้มีการสละสิทธิ์ไว้เป็นลายลักษณ์อักษร
          </p>
          <p className="terms-content__paragraph">
            29.6
            เงื่อนไขการให้บริการนี้มีไว้เพื่อท่านและประโยชน์ของUrbaanเท่านั้น
            และไม่ใช่เพื่อประโยชน์ของบุคคลหรือนิติบุคคลอื่นใด
            เว้นแต่บริษัทย่อยและบริษัทในเครือของ Urbaan และผู้รับช่วงสิทธิ์
          </p>
          <p className="terms-content__paragraph">
            29.7 ท่านตกลงที่จะปฏิบัติตามกฎหมาย บทกฎหมาย
            ข้อบังคับและประมวลกฎหมายที่บังคับใช้ทั้งหมดที่เกี่ยวกับการต่อต้านการติดสินบนและการทุจริต
            รวมทั้งยืนยันว่าท่านได้และจะกำหนดนโยบายและระเบียบทั้งหมดที่จำเป็นเพื่อรับรองการปฏิบัติตามข้อกำหนดดังกล่าว
          </p>
          <p className="terms-content__paragraph">
            29.8 หากมีคำถามหรือข้อกังวลเกี่ยวกับเงื่อนไขการให้บริการนี้
            หรือมีปัญหาที่เกิดจากเงื่อนไขการให้บริการนี้หรือบนแพลตฟอร์ม
            โปรดติดต่อ Urbaan ที่ admin@urbaancommunities.com หนังสือบอกกล่าว:
            โปรดส่งหนังสือบอกกล่าวทั้งหมดไปที่ตามที่ตั้งบริษัท อินไซท์ สเคป
            จํากัด ส่งถึง ฝ่ายดูแลผู้ใช้บริการของบริษัท อินไซท์ สเคป จํากัด
          </p>
          <p className="terms-content__heading">การคุ้มครองทรัพย์สินทางปัญญา</p>
          <p className="terms-content__paragraph">
            Urbaan ให้ความสำคัญต่อการคุ้มครองทรัพย์สินทางปัญญาและสิทธิทางปัญญาของผู้ทรงสิทธิอย่างจริงจังและจะเอาผิดกับการใช้ทรัพย์สินทางปัญญาในลักษณะที่เป็นการละเมิดกฎหมายที่ใช้บังคับผู้ใดที่มีหน้าที่รับผิดชอบในการตรวจสอบให้แน่ใจว่าผลิตภัณฑ์และเนื้อหาของตน
            (เช่น รูปภาพ คำอธิบาย เป็นต้น)
            ไม่ได้เป็นการละเมิดสิทธิ์ในทรัพย์สินทางปัญญาของบุคคลอื่นใด
            รายการสินค้าอาจถูกลบโดยไม่ต้องแจ้งให้ทราบหากมีรายงานว่าผู้ใดได้มีการละเมิดทรัพย์สินทางปัญญาใด
            ๆ ที่ไม่ใช่ของผู้นั้นเอง
          </p>
          <p className="terms-content__paragraph">
            ทั้งนี้ Urbaan มีมาตรการสอดส่อง
            ควบคุมไม่ให้มีการละเมิดทรัพย์สินทางปัญญาเกิดขึ้นบนแพลตฟอร์มของ
            Urbaan เมื่อมีการละเมิดทรัพย์สินทางปัญญาเกิดขึ้น
            ก็ยังคงเป็นความรับผิดชอบของผู้ทำละเมิดเอง
            ดังนั้นผู้ขายจะต้องมั่นใจว่ารายการสินค้าที่นำมาลงขายในส่วนของ
            ตัวผลิตภัณฑ์ ชื่อ คำอธิบายเนื้อหา รวมถึงรูปภาพสินค้า
            จะต้องไม่เข้าข่ายละเมิดทรัพย์สินทางปัญญาของบุคคลอื่น 
          </p>
          <p className="terms-content__paragraph">
            นอกจากนี้ Urbaan ยังให้ความสำคัญกับการการละเมิดลิขสิทธิ์บนแพลตฟอร์ม
            Urbaan ได้ดำเนินการบังคับใช้ มาตรการแจ้งเตือนและเอาออก (The Notice
            and Takedown Measure) ตามกฎหมายลิขสิทธิ์ที่ได้มีการแก้ไขใหม่
            โดยเจ้าของลิขสิทธิ์สามารถส่งคำแจ้งเตือน (Notice) มายัง Urbaan
            เพื่อให้ Urbaan นำข้อมูลคอมพิวเตอร์ที่มีการละเมิดลิขสิทธิ์
            ออกจากแพลตฟอร์มของ Urbaan (Takedown) ได้อย่างทันท่วงที
            เพื่อยับยั้งการละเมิดได้อย่างรวดเร็วมากยิ่งขึ้น
          </p>
          <p className="terms-content__heading">
            การละเมิดสิทธิ์ในทรัพย์สินทางปัญญาคืออะไร
          </p>
          <p className="terms-content__paragraph">
            การละเมิดสิทธิ์ในทรัพย์สินทางปัญญาหมายถึงการขายผลิตภัณฑ์ที่มีเครื่องหมายการค้าจที่ดทะเบียน/เนื้อหาที่มีลิขสิทธิ์/การออกแบบทางอุตสาหกรรมที่ไม่ได้รับอนุญาตจากเจ้าของทรัพย์สินทางปัญญา
          </p>
          <p className="terms-content__paragraph">
            ตัวอย่างทั่วไป (โดยสังเขป)
            ของการละเมิดทรัพย์สินทางปัญญาบนแพลตฟอร์มได้แก่
          </p>
          <p className="terms-content__sub-paragraph">
            1)  การละเมิดเครื่องหมายการค้า/สิทธิบัตร/สินค้าปลอมหรือเลียนแบบ
          </p>
          <p className="terms-content__sub-paragraph">
            การใช้เครื่องหมายการค้า หรือชื่อทางการค้า เพื่อโฆษณา, อ้างอิง ผ่าน
            ชื่อ รูปภาพ หรือคำอธิบายเนื้อหาสินค้า
            รวมทั้งจำหน่ายสินค้าปลอมแปลงภายใต้เครื่องหมายการค้า
            (รวมถึงมีความคล้ายคลึงกัน) โดยไม่ได้รับอนุญาตจากบุคคลหรือองค์กรอันเป็นเจ้าของสิทธิ์เครื่องหมายการค้า
          </p>
          <p className="terms-content__sub-paragraph">2) การละเมิดสิทธิบัตร</p>
          <p className="terms-content__sub-paragraph">
            การขายมีไว้เพื่อเสนอขาย
            หรือนำเข้ามาในราชอาณาจักรซึ่งผลิตภัณฑ์ตามสิทธิบัตรหรือผลิตภัณฑ์ที่ใช้กรรมวิธีตามสิทธิบัตร
            โดยไม่ได้รับอนุญาตจากผู้ทรงสิทธิบัตร
            รวมถึงผลิตภัณฑ์ที่ใช้การออกแบบ/สิทธิบัตรของผู้ทรงสิทธิบัตรโดยไม่ได้รับอนุญาต
          </p>
          <p className="terms-content__sub-paragraph">3) การละเมิดลิขสิทธิ์</p>
          <p className="terms-content__sub-paragraph">
            การนำผลงานของผู้อื่นมาใช้ เผยแพร่ ดัดแปลง ทำซ้ำ
            ในส่วนของรูปภาพ/โลโก้/เนื้อหาที่มีลิขสิทธิ์ รวมถึงแต่ไม่จำกัดเพียง
            คำอธิบาย คำแนะนำ ส่วนผสม รายละเอียดผลิตภัณฑ์
            โดยผู้เป็นเจ้าของลิขสิทธิ์หรือผู้ทรงสิทธิไม่อนุญาต
          </p>
          <p className="terms-content__heading">
            เอกสารสำคัญสำหรับใช้ร้องเรียนสินค้าละเมิดทรัพย์สินทางปัญญา
          </p>
          <p className="terms-content__paragraph">
            1.  สินค้าปลอมแปลง / ละเมิดเครื่องหมายการค้า
          </p>
          <p className="terms-content__sub-paragraph">
            1.1 หนังสือมอบอำนาจ (กรณีเป็นตัวแทนจำหน่าย / ตัวแทนผู้ร้องเรียน)
          </p>
          <p className="terms-content__sub-paragraph">
            1.2 หนังสือสำคัญแสดงการจดทะเบียนเครื่องหมายการค้า
          </p>
          <p className="terms-content__sub-paragraph">
            1.3 รูปภาพและข้อมูลเพิ่มเติมเกี่ยวกับราคากลางของผลิตภัณฑ์
          </p>
          <p className="terms-content__paragraph">
            2.  ละเมิดสิทธิบัตรการออกแบบ
          </p>
          <p className="terms-content__sub-paragraph">
            2.1 หนังสือมอบอำนาจ (กรณีเป็นตัวแทนจำหน่าย / ตัวแทนผู้ร้องเรียน)
          </p>
          <p className="terms-content__sub-paragraph">
            2.2 หนังสือสำคัญแสดงการจดทะเบียนสิทธิบัตรการออกแบบผลิตภัณฑ์
          </p>
          <p className="terms-content__sub-paragraph">
            2.3 รูปภาพและข้อมูลเพิ่มเติมเกี่ยวกับผลิตภัณฑ์
          </p>
          <p className="terms-content__paragraph">
            3.  ละเมิดสิทธิบัตรสิ่งประดิษฐ์
          </p>
          <p className="terms-content__sub-paragraph">
            3.1 หนังสือมอบอำนาจ (กรณีเป็นตัวแทนจำหน่าย / ตัวแทนผู้ร้องเรียน)
          </p>
          <p className="terms-content__sub-paragraph">
            3.2 หนังสือสำคัญแสดงการจดทะเบียนสิทธิบัตรการประดิษฐ์
          </p>
          <p className="terms-content__sub-paragraph">
            3.3 รูปภาพและข้อมูลเพิ่มเติมเกี่ยวกับผลิตภัณฑ์ 
          </p>
          <p className="terms-content__paragraph">4.  ละเมิดลิขสิทธิ์</p>
          <p className="terms-content__sub-paragraph">
            4.1 รูปภาพต้นฉบับ (มีลายน้ำ)
          </p>
          <p className="terms-content__sub-paragraph">
            4.2 ลิงก์สินค้าหรือหลักฐานอื่นๆ ที่บ่งบอกถึงการเป็นเจ้าของผลงาน เช่น
            เว็บแพลตฟอร์มที่ลงรูปภาพต้นฉบับ 
          </p>
          <p className="terms-content__heading">
            การรายงานการละเมิดสิทธิ์ในทรัพย์สินทางปัญญา
          </p>
          <p className="terms-content__paragraph">
            หากต้องการรายงานการละเมิดสิทธิ์ในทรัพย์สินทางปัญญา (IP)
            รบกวนกรอกเอกสารภายในลิงก์ดังต่อไปนี้ 
          </p>
          <p className="terms-content__paragraph">
            1. สำหรับร้านค้าทางการ (Urbaan Mall) และผู้ขายที่ได้รับการคัดเลือก
            (Selected Seller):
            ช่องทางการยื่นคำร้องด้านทรัพย์สินทางปัญญาของแบรนด์ (Urbaan Brand IP
            Portal )
          </p>
          <p className="terms-content__paragraph">
            2. สำหรับร้านค้าทั่วไป (Non-Mall Sellers)
          </p>
          <p className="terms-content__heading">หมายเหตุ</p>
          <p className="terms-content__paragraph">
            ผู้ขายที่มีสิทธิ์เข้าถึงช่องทางการยื่นคำร้องด้านทรัพย์สินทางปัญญาของแบรนด์
            (Urbaan Brand IP Portal) จะได้รับอีเมลยืนยันการเข้าถึงจากทีมงาน
            Urbaan
          </p>
          <p className="terms-content__paragraph">
            ทาง Urbaan จะทำการตรวจสอบคำร้องเรียนผ่านเอกสารดังกล่าวอย่างเคร่งครัด
            พร้อมทั้งติดต่อประสานงานกับทางเจ้าของสิทธิ์หรือหน่วยงานที่เกี่ยวข้องเพื่อแก้ไขปัญหาอย่างรวดเร็ว
          </p>
          <p className="terms-content__paragraph">
            เพื่อให้ขั้นตอนการตรวจสอบดำเนินไปอย่างรวดเร็ว ทาง Urbaan
            จำเป็นต้องใช้เอกสารสำคัญที่ระบุถึงการเป็นเจ้าของกรรมสิทธิ์หรือเอกสารที่เกี่ยวข้อง
            รวมทั้งข้อมูลในส่วนของสินค้าที่เข้าข่ายเป็นสินค้าละเมิด
            เพื่อประกอบการพิจารณาคำร้องเรียน
          </p>
          <p className="terms-content__heading">โปรดทราบ</p>
          <p className="terms-content__paragraph">
            อ้างอิงตามกฎหมายคุ้มครองทรัพย์สินทางปัญญาแห่งประเทศไทย Urbaan
            ไม่สามารถระงับสินค้าได้หากเป็นคำร้องเรียนระงับสินค้าที่ไม่ได้จัดจำหน่ายโดยตัวแทนจำหน่ายอย่างถูกต้อง
            เนื่องจากกรณีดังกล่าวเป็นสัญญาข้อตกลงระหว่างบริษัทและผู้ขาย
            และกฎหมายไม่ได้คุ้มครองในส่วนดังกล่าว
            จึงแนะนำผู้ร้องเรียนติดต่อไปยังผู้ขายโดยตรง
            โดยหากคำร้องเรียนเกี่ยวข้องกับการละเมิดทรัพย์สินทางปัญญาหรือละเมิดลิขสิทธิ์
            ทาง Urbaan
            ยินดีรับเรื่องร้องเรียนและให้ผู้ร้องดำเนินการตามขั้นตอนที่แจ้งไว้
            เพื่อให้ขั้นตอนการตรวจสอบดำเนินไปอย่างรวดเร็ว  
          </p>
          {/* <div ref={bottomDivRef}></div> */}
        </div>
        <div className="terms-cta">
          <button onClick={onClose}>Decline</button>
          <button disabled={!isAtBottom} onClick={onAgree}>
            Accept
          </button>
        </div>
      </div>
    );
  };

  if (isFullScreen) {
    classNames.push("terms--fullscreen");

    return getContent();
  }

  return <Overlay>{getContent()}</Overlay>;
};
